(() => {

  const builderSelectors = {
    selected: `
      [data-builder-option-selected], 
      [data-step-type="collection"] .builder-card--selected,
      [data-step-type="option"] .builder-card--selected,
      [data-step-type="product_in_collection"] .builder-card--selected,
      [data-step-type="product_in_collection"] builder-product-step.builder-product-step--active
    `,
    finalSelection: `
      [data-step-type="collection"] .builder-card--selected,
      [data-step-type="option"] .builder-card--selected,
      [data-step-type="product_in_collection"] builder-product-step.builder-product-step--active
    `,
    choice: `
      [data-builder-option], 
      .builder-card, 
      .builder-product-step
    `,
    elements: {
      builder: {
        tag: `builder-main`,
        class: `builder`,
      },
      steps: {
        steps: "builder-steps",
        substep: "builder-step"
      },
      substeps: {
        substeps: "builder-substeps",
        substep: "builder-substep"
      },
      cards: {
        element: `.builder-card`,
        selected: `.builder-card--selected`
      }
    },
    Variant: {
      option: `[data-variant3d-option]`,
      selected: `[data-variant3d-option-selected]`
    }
  };


  /* ==================== Libs / Functions ==================== */

  /* ----- Custom Libs ----- */

  const uuid = function () {

    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );

  }
  
  /* ----- Focal Libs ----- */

  // js/helper/currency.js
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }


  /* ----- Focal Libs ----- */

  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function (eventType) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam
    });
    return this;
  };
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };
  var main_default = Delegate;

  // js/components/input-binding-manager.js
  var InputBindingManager = class {
    constructor() {
      this.delegateElement = new main_default(document.body);
      this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this));
    }
    _onValueChanged(event, target) {
      const boundElement = document.getElementById(target.getAttribute("data-bind-value"));
      if (boundElement) {
        if (target.tagName === "SELECT") {
          target = target.options[target.selectedIndex];
        }
        boundElement.innerHTML = target.hasAttribute("title") ? target.getAttribute("title") : target.value;
      }
    }
  };

  // js/helper/event.js
  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: data
    }));
  }
  function triggerNonBubblingEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: false,
      detail: data
    }));
  }

  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  // node_modules/tabbable/dist/index.esm.js
  var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
  var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
  var matches = typeof Element === "undefined" ? function () {
  } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var isContentEditable = function isContentEditable2(node) {
    return node.contentEditable === "true";
  };
  var getTabindex = function getTabindex2(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!isNaN(tabindexAttr)) {
      return tabindexAttr;
    }
    if (isContentEditable(node)) {
      return 0;
    }
    if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
      return 0;
    }
    return node.tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
  };
  var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
  };
  var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === "SUMMARY";
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || node.ownerDocument;
    var queryRadios = function queryRadios2(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
  };
  var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isHidden = function isHidden2(node, displayCheck) {
    if (getComputedStyle(node).visibility === "hidden") {
      return true;
    }
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
      return true;
    }
    if (!displayCheck || displayCheck === "full") {
      while (node) {
        if (getComputedStyle(node).display === "none") {
          return true;
        }
        node = node.parentElement;
      }
    } else if (displayCheck === "non-zero-area") {
      var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
      return width === 0 && height === 0;
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === "LEGEND") {
              if (child.contains(node)) {
                return false;
              }
              return true;
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
      return false;
    }
    return true;
  };
  var tabbable = function tabbable2(el, options) {
    options = options || {};
    var regularTabbables = [];
    var orderedTabbables = [];
    var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    candidates.forEach(function (candidate, i) {
      var candidateTabindex = getTabindex(candidate);
      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate
        });
      }
    });
    var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
      return a.node;
    }).concat(regularTabbables);
    return tabbableNodes;
  };
  var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
  var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) {
      throw new Error("No node provided");
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options, node);
  };

  // node_modules/focus-trap/dist/focus-trap.esm.js
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var activeFocusTraps = function () {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];
          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }
        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();
  var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
  };
  var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
  };
  var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
  };
  var delay = function delay2(fn) {
    return setTimeout(fn, 0);
  };
  var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function (value, i) {
      if (fn(value)) {
        idx = i;
        return false;
      }
      return true;
    });
    return idx;
  };
  var valueOrHandler = function valueOrHandler2(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === "function" ? value.apply(void 0, params) : value;
  };
  var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
  };
  var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);
    var state = {
      containers: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var containersContain = function containersContain2(element) {
      return !!(element && state.containers.some(function (container) {
        return container.contains(element);
      }));
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
      var optionValue = config[optionName];
      if (typeof optionValue === "function") {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
      var node = getNodeForOption("initialFocus");
      if (node === false) {
        return false;
      }
      if (node === void 0) {
        if (containersContain(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption("fallbackFocus");
        }
      }
      if (!node) {
        throw new Error("Your focus-trap needs to have at least one focusable element");
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
      state.tabbableGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable(container);
        if (tabbableNodes.length > 0) {
          return {
            container,
            firstTabbableNode: tabbableNodes[0],
            lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
          };
        }
        return void 0;
      }).filter(function (group) {
        return !!group;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
        throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      }
    };
    var tryFocus = function tryFocus2(node) {
      if (node === false) {
        return;
      }
      if (node === doc.activeElement) {
        return;
      }
      if (!node || !node.focus) {
        tryFocus2(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
      var node = getNodeForOption("setReturnFocus", previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
      var target = getActualTarget(e);
      var targetContained = containersContain(target);
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    };
    var checkTab = function checkTab2(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
          var container = _ref.container;
          return container.contains(target);
        });
        if (containerIndex < 0) {
          if (e.shiftKey) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        destinationNode = getNodeForOption("fallbackFocus");
      }
      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      }
    };
    var checkKey = function checkKey2(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }
      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };
    var checkClick = function checkClick2(e) {
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener("focusin", checkFocusIn, true);
      doc.addEventListener("mousedown", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("touchstart", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("click", checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener("keydown", checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };
    var removeListeners = function removeListeners2() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener("focusin", checkFocusIn, true);
      doc.removeEventListener("mousedown", checkPointerDown, true);
      doc.removeEventListener("touchstart", checkPointerDown, true);
      doc.removeEventListener("click", checkClick, true);
      doc.removeEventListener("keydown", checkKey, true);
      return trap;
    };
    trap = {
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, "onActivate");
        var onPostActivate = getOption(activateOptions, "onPostActivate");
        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        if (onActivate) {
          onActivate();
        }
        var finishActivation = function finishActivation2() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          if (onPostActivate) {
            onPostActivate();
          }
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = void 0;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(deactivateOptions, "onDeactivate");
        var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
        var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
        if (onDeactivate) {
          onDeactivate();
        }
        var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
        var finishDeactivation = function finishDeactivation2() {
          delay(function () {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }
        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }
        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === "string" ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        return this;
      }
    };
    trap.updateContainerElements(elements);
    return trap;
  };

  // js/helper/section.js
  function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes("shopify:section")) {
      if (domElement.hasAttribute("section") && domElement.getAttribute("section") === event.detail.sectionId) {
        executeCallback = true;
      }
    } else if (event.type.includes("shopify:block") && event.target === domElement) {
      executeCallback = true;
    }
    if (executeCallback) {
      callback(event);
    }
  }

  // js/helper/image.js
  function getSizedMediaUrl(media, size) {
    let src = typeof media === "string" ? media : media["preview_image"] ? media["preview_image"]["src"] : media["url"];
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  function getMediaSrcset(media, sizeList) {
    let srcset = [], supportedSizes = typeof media === "string" ? sizeList : getSupportedSizes(media, sizeList);
    supportedSizes.forEach((supportedSize) => {
      srcset.push(`${getSizedMediaUrl(media, supportedSize + "x")} ${supportedSize}w`);
    });
    return srcset.join(",");
  }
  function getSupportedSizes(media, desiredSizes) {
    let supportedSizes = [], mediaWidth = media["preview_image"]["width"];
    desiredSizes.forEach((width) => {
      if (mediaWidth >= width) {
        supportedSizes.push(width);
      }
    });
    return supportedSizes;
  }
  function imageLoaded(image) {
    return new Promise((resolve) => {
      if (!image || image.tagName !== "IMG" || image.complete) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }

  // js/helper/animation.js
  var CustomAnimation = class {
    constructor(effect) {
      this._effect = effect;
      this._playState = "idle";
      this._finished = Promise.resolve();
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
    }
    cancel() {
      this.animationEffects.forEach((animationEffect) => animationEffect.cancel());
    }
    finish() {
      this.animationEffects.forEach((animationEffect) => animationEffect.finish());
    }
    play() {
      this._playState = "running";
      this._effect.play();
      this._finished = this._effect.finished;
      this._finished.then(() => {
        this._playState = "finished";
      }, (rejection) => {
        this._playState = "idle";
      });
    }
  };
  var CustomKeyframeEffect = class {
    constructor(target, keyframes, options = {}) {
      if (!target) {
        return;
      }
      if ("Animation" in window) {
        this._animation = new Animation(new KeyframeEffect(target, keyframes, options));
      } else {
        options["fill"] = "forwards";
        this._animation = target.animate(keyframes, options);
        this._animation.pause();
      }
      this._animation.addEventListener("finish", () => {
        target.style.opacity = keyframes.hasOwnProperty("opacity") ? keyframes["opacity"][keyframes["opacity"].length - 1] : null;
        target.style.visibility = keyframes.hasOwnProperty("visibility") ? keyframes["visibility"][keyframes["visibility"].length - 1] : null;
      });
    }
    get finished() {
      if (!this._animation) {
        return Promise.resolve();
      }
      return this._animation.finished ? this._animation.finished : new Promise((resolve) => this._animation.onfinish = resolve);
    }
    play() {
      if (this._animation) {
        this._animation.startTime = null;
        this._animation.play();
      }
    }
    cancel() {
      if (this._animation) {
        this._animation.cancel();
      }
    }
    finish() {
      if (this._animation) {
        this._animation.finish();
      }
    }
  };
  var GroupEffect = class {
    constructor(childrenEffects) {
      this._childrenEffects = childrenEffects;
      this._finished = Promise.resolve();
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._childrenEffects.flatMap((effect) => {
        return effect instanceof CustomKeyframeEffect ? effect : effect.animationEffects;
      });
    }
  };
  var ParallelEffect = class extends GroupEffect {
    play() {
      const promises = [];
      for (const effect of this._childrenEffects) {
        effect.play();
        promises.push(effect.finished);
      }
      this._finished = Promise.all(promises);
    }
  };
  var SequenceEffect = class extends GroupEffect {
    play() {
      this._finished = new Promise(async (resolve, reject) => {
        try {
          for (const effect of this._childrenEffects) {
            effect.play();
            await effect.finished;
          }
          resolve();
        } catch (exception) {
          reject();
        }
      });
    }
  };


  /* ----- Other ----- */

  var isScrollable = (element) => {
    const computedStyle = window.getComputedStyle(element);
    if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
      return canOverflow(computedStyle.overflowY) || canOverflow(computedStyle.overflowX) || element === scrollingElement(element);
    }
    return false;
  };
  var canOverflow = (overflow) => {
    return overflow !== "visible" && overflow !== "clip";
  };

  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  // js/custom-element/behavior/openable-element.js
  var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => filterShopifyEvent(event, this, () => this.open = true));
        this.rootDelegate.on("shopify:section:deselect", (event) => filterShopifyEvent(event, this, () => this.open = false));
      }
      if (this.hasAttribute("append-body")) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute("append-body");
        if (existingNode && existingNode !== this) {
          existingNode.replaceWith(this.cloneNode(true));
          this.remove();
        } else {
          document.body.appendChild(this);
        }
      }
    }
    connectedCallback() {
      this.delegate.on("click", ".openable__overlay", () => this.open = false);
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    get requiresLoading() {
      return this.hasAttribute("href");
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          await this._load();
          this.clientWidth;
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }
    get shouldTrapFocus() {
      return true;
    }
    get returnFocusOnDeactivate() {
      return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
    }
    get focusTrap() {
      return this._focusTrap = this._focusTrap || createFocusTrap(this, {
        fallbackFocus: this,
        initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
        clickOutsideDeactivates: (event) => !(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
        allowOutsideClick: (event) => event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
        returnFocusOnDeactivate: this.returnFocusOnDeactivate,
        onDeactivate: () => this.open = false,
        preventScroll: true
      });
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "open":
          if (oldValue === null && newValue === "") {
            if (this.shouldTrapFocus) {
              setTimeout(() => this.focusTrap.activate(), 150);
            }
            triggerEvent(this, "openable-element:open");
          } else if (newValue === null) {
            if (this.shouldTrapFocus) {
              this.focusTrap.deactivate();
            }
            triggerEvent(this, "openable-element:close");
          }
      }
    }
    async _load() {
      if (!this.requiresLoading) {
        return;
      }
      triggerNonBubblingEvent(this, "openable-element:load:start");
      const response = await fetch(this.getAttribute("href"));
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
      this.removeAttribute("href");
      triggerNonBubblingEvent(this, "openable-element:load:end");
    }
  };

  // js/helper/product-loader.js
  var ProductLoader = class {
    static load(productHandle) {
      if (!productHandle) {
        return;
      }
      if (this.loadedProducts[productHandle]) {
        return this.loadedProducts[productHandle];
      }
      this.loadedProducts[productHandle] = new Promise(async (resolve) => {
        const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}.js`);
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      });
      return this.loadedProducts[productHandle];
    }
  };
  __publicField(ProductLoader, "loadedProducts", {});

  var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);
    var state = {
      containers: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var containersContain = function containersContain2(element) {
      return !!(element && state.containers.some(function (container) {
        return container.contains(element);
      }));
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
      var optionValue = config[optionName];
      if (typeof optionValue === "function") {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
      var node = getNodeForOption("initialFocus");
      if (node === false) {
        return false;
      }
      if (node === void 0) {
        if (containersContain(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption("fallbackFocus");
        }
      }
      if (!node) {
        throw new Error("Your focus-trap needs to have at least one focusable element");
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
      state.tabbableGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable(container);
        if (tabbableNodes.length > 0) {
          return {
            container,
            firstTabbableNode: tabbableNodes[0],
            lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
          };
        }
        return void 0;
      }).filter(function (group) {
        return !!group;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
        throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      }
    };
    var tryFocus = function tryFocus2(node) {
      if (node === false) {
        return;
      }
      if (node === doc.activeElement) {
        return;
      }
      if (!node || !node.focus) {
        tryFocus2(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
      var node = getNodeForOption("setReturnFocus", previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
      var target = getActualTarget(e);
      var targetContained = containersContain(target);
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    };
    var checkTab = function checkTab2(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
          var container = _ref.container;
          return container.contains(target);
        });
        if (containerIndex < 0) {
          if (e.shiftKey) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        destinationNode = getNodeForOption("fallbackFocus");
      }
      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      }
    };
    var checkKey = function checkKey2(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }
      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };
    var checkClick = function checkClick2(e) {
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener("focusin", checkFocusIn, true);
      doc.addEventListener("mousedown", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("touchstart", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("click", checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener("keydown", checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };
    var removeListeners = function removeListeners2() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener("focusin", checkFocusIn, true);
      doc.removeEventListener("mousedown", checkPointerDown, true);
      doc.removeEventListener("touchstart", checkPointerDown, true);
      doc.removeEventListener("click", checkClick, true);
      doc.removeEventListener("keydown", checkKey, true);
      return trap;
    };
    trap = {
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, "onActivate");
        var onPostActivate = getOption(activateOptions, "onPostActivate");
        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        if (onActivate) {
          onActivate();
        }
        var finishActivation = function finishActivation2() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          if (onPostActivate) {
            onPostActivate();
          }
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = void 0;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(deactivateOptions, "onDeactivate");
        var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
        var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
        if (onDeactivate) {
          onDeactivate();
        }
        var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
        var finishDeactivation = function finishDeactivation2() {
          delay(function () {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }
        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }
        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === "string" ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        return this;
      }
    };
    trap.updateContainerElements(elements);
    return trap;
  };

  // js/helper/dom.js
  function getSiblings(element, filter, includeSelf = false) {
    let siblings = [];
    let currentElement = element;
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    if (includeSelf) {
      siblings.push(element);
    }
    currentElement = element;
    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    return siblings;
  }
  async function resolveAsyncIterator(target) {
    const processedTarget = [];
    if (!(target != null && typeof target[Symbol.iterator] === "function")) {
      target = [target];
    }
    for (const targetItem of target) {
      if (typeof targetItem[Symbol.asyncIterator] === "function") {
        for await (const awaitTarget of targetItem) {
          processedTarget.push(awaitTarget);
        }
      } else {
        processedTarget.push(targetItem);
      }
    }
    return processedTarget;
  }






  // js/helper/library-loader.js
  var LibraryLoader = class {
    static load(libraryName) {
      const STATUS_REQUESTED = "requested", STATUS_LOADED = "loaded";
      const library = this.libraries[libraryName];
      if (!library) {
        return;
      }
      if (library.status === STATUS_REQUESTED) {
        return library.promise;
      }
      if (library.status === STATUS_LOADED) {
        return Promise.resolve();
      }
      let promise;
      if (library.type === "script") {
        promise = new Promise((resolve, reject) => {
          let tag = document.createElement("script");
          tag.id = library.tagId;
          tag.src = library.src;
          tag.onerror = reject;
          tag.onload = () => {
            library.status = STATUS_LOADED;
            resolve();
          };
          document.body.appendChild(tag);
        });
      } else {
        promise = new Promise((resolve, reject) => {
          let tag = document.createElement("link");
          tag.id = library.tagId;
          tag.href = library.src;
          tag.rel = "stylesheet";
          tag.type = "text/css";
          tag.onerror = reject;
          tag.onload = () => {
            library.status = STATUS_LOADED;
            resolve();
          };
          document.body.appendChild(tag);
        });
      }
      library.promise = promise;
      library.status = STATUS_REQUESTED;
      return promise;
    }
  };
  __publicField(LibraryLoader, "libraries", {
    flickity: {
      tagId: "flickity",
      src: window.themeVariables.libs.flickity,
      type: "script"
    },
    photoswipe: {
      tagId: "photoswipe",
      src: window.themeVariables.libs.photoswipe,
      type: "script"
    },
    qrCode: {
      tagId: "qrCode",
      src: window.themeVariables.libs.qrCode,
      type: "script"
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: "link"
    }
  });

  // js/helper/media-features.js
  var MediaFeatures = class {
    static prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    static supportsHover() {
      return window.matchMedia("(pointer: fine)").matches;
    }
  };























































  /* ==================== Builder ==================== */

  var Variant3D = {
    API: {
      key: "191|102|nJ6W4hxndN4YQyKBXRe9JujBXtaRgSWptCh3SkaX"
    },
    debug: {
      styles: {
        default: "color: currentColor;",
        error: "color: red; font-weight: bold;",
        warning: "color: orange; font-weight: bold;",
        success: "color: green; font-weight: bold;",
        info: "color: blue; font-weight: bold;",
        app: "color: #5B63D3; font-weight: bold;"
      },
      appstub: "%c[BUILDER]%c"
    },
    storage: {
      product: null
    },
    selectors: {
      
    }
  };

  class Variant3DHelper {
    static hasVariant3DProperties(element) {
      return Array.from(element.attributes).some(attr => attr.name.includes('data-variant3d'));
    }

    static getVariant3DAttributes(element) {
      return Array.from(element.attributes)
        .filter(attr => attr.name.includes('data-variant3d'))
        .reduce((acc, attr) => {
          acc[attr.name] = attr.value;
          return acc;
        }, {});
    }

    static getVariant3DAttributesAsArray(element) {
      return Array.from(element.attributes)
        .filter(attr => attr.name.includes('data-variant3d'))
        .map(attr => ({ attribute: attr.name, value: attr.value }));
    }

    static getVariant3DOptions(element) {
      return Array.from(element.attributes)
        .filter(attr => attr.name.includes('data-variant3d'))
        .map(attr => ({ attribute: attr.name, value: attr.value }));
    }

    static filterVariant3DOptions(nodeList) {
      if (!nodeList || nodeList?.length === 0) {
        return;
      }
      const filtered = Array.from(nodeList).filter(el => el.matches(builderSelectors.Variant.option));
      return filtered;
      // return nodeList;
    }

    static filterVariant3DSelections(nodeList) {
      if (!nodeList || nodeList?.length === 0) {
        return;
      }
      // const filtered = Array.from(nodeList).filter(el => el.matches(builderSelectors.Variant.selected));
      // return filtered;
      return nodeList;
    }

    static updateViewerFromElement(element) {

      if (!element) {
        return;
      }

      const builder = element.closest(`builder-main`);

      if (!builder) {
        return;
      }
      
      if (Variant3DHelper.hasVariant3DProperties(element)) {
        const variant3DAttributes = Variant3DHelper.getVariant3DAttributes(element);
        
        this.dispatchEvent(new CustomEvent("viewer:update", {
          bubbles: true,
          detail: {
            element: element,
            variant3DAttributes: variant3DAttributes
          }
        }));
      }

    }

    static sanitizeVariant3DPayload(payload) {

      // Create a deep copy to avoid mutating the original
      const sanitized = JSON.parse(JSON.stringify(payload));

      if (sanitized.options) {
        // Remove duplicates from meshes array
        if (Array.isArray(sanitized.options.meshes)) {
          sanitized.options.meshes = removeDuplicatesByMeshtag(sanitized.options.meshes);
        }

        // Remove duplicates from materials array
        if (Array.isArray(sanitized.options.materials)) {
          sanitized.options.materials = removeDuplicatesByMeshtag(sanitized.options.materials);
        }
      }

      return sanitized;

    }

  }

  function removeDuplicatesByTag(items) {
    const seen = new Set();
    return items.filter(item => {
      if (seen.has(item.tag)) {
        return false;
      }
      seen.add(item.tag);
      return true;
    });
  }

  function removeDuplicatesByMeshtag(items) {
    const seen = new Set();
    const filtered = items.filter(item => {
      if (seen.has(item.meshTag)) {
        return false;
      }
      seen.add(item.meshTag);
      return true;
    });
    return filtered;
  }


    

  


  /* ==================== Builder ==================== */


  class BuilderHelper {

    static selectorToClass(selector) {
      if (typeof selector == "string") {
        return selector.replace('.', '');
      }
    }

  }


  // js/custom-element/custom-html-element.js
  var Builder = class extends CustomHTMLElement {

    /* ---------- Setup ---------- */
    
    constructor() {
      super();
    }

    connectedCallback() {

      // this._init();

    }

    _init() {

      /* --- Add Event Listeners --- */
      
      // Single

      this.addEventListener("builder:ready", this._onReady.bind(this));

      this.addEventListener("builder:steps:change:start", this._onStepChangeStart.bind(this));
      this.addEventListener("builder:steps:change:updated", this._onStepChangeUpdated.bind(this));
      this.addEventListener("builder:steps:change:end", this._onStepChangeEnd.bind(this));
      this.addEventListener("builder:steps:change:arrive", this._onStepChangeArrive.bind(this));
      
      this.addEventListener("builder:substeps:change:updated", this._onSubstepChangeUpdated.bind(this));

      this.addEventListener("builder:navigation:refresh", this._onNavigationRefresh.bind(this));
      this.addEventListener("builder:navigation:reset", this._onNavigationReset.bind(this));


      // Multiple

      const builder = this;

      this.querySelectorAll(`[data-action="start"]`).forEach((el) => {
        el.addEventListener("click", this._onClickStart.bind(builder));
      });
      this.querySelectorAll(`[data-action="restart"]`).forEach((el) => {
        el.addEventListener("click", this._onClickRestart.bind(builder));
      });
      this.querySelectorAll(`[data-action="next-step"]`).forEach((el) => {
        el.addEventListener("click", this._onClickNextStep.bind(builder));
      });
      this.querySelectorAll(`[data-action="prev-step"]`).forEach((el) => {
        el.addEventListener("click", this._onClickPrevStep.bind(builder));
      });
      this.querySelectorAll(`[data-action="goto-step"]`).forEach((el) => {
        el.addEventListener("click", this._onClickGotoStep.bind(builder));
      });

      this.delegate.on("click", `[data-action="goto-step"]`, () => {
        this._onClickGotoStep.bind(builder);
      });

      // Start

      this.updateTotalStepNumber();
      this._updateButtonStates();

      this.dispatchEvent(new CustomEvent("builder:ready", {
        bubbles: true,
        detail: {
          element: this
        }
      }));

      // this.settings = this.builderSettings;

    }

    /* ---------- Functions ---------- */

    updateTotalStepNumber() {

      const labels = this.labelStepTotal;
      const steps = this.steps;

      labels.forEach((el) => {
        el.textContent = steps.totalStepsNumber;
      });
      
    }

    updateCurrentStepNumber() {

      const labels = this.labelStepCurrent;
      const steps = this.steps;

      labels.forEach((el) => {
        el.textContent = steps.currentStepNumber;
      });
      
    }

    allStepsComplete() {
      // Check if all steps (except summary) are complete
      const steps = this.steps.querySelectorAll("builder-step");

      for (let step of steps) {
        // Skip summary step
        if (step.dataset.stepType === 'summary') {
          continue;
        }

        // If any non-summary step is not complete, return false
        if (!step.complete) {
          return false;
        }
      }

      return true;
    }

    reset() {

      // Resets all builder values.

      // Loop through all steps and reset them
      const steps = this.steps.querySelectorAll("builder-step");
      steps.forEach(step => {
        step.reset();
      });

      // Loop through all substeps and reset them
      const substeps = this.steps.querySelector("builder-substeps");
      if (substeps) {
        substeps.reset();
      }

      // Update button states
      this._updateButtonStates();

      this.viewer.reset();

      // Dispatch event to refresh navigation
      this.dispatchEvent(new CustomEvent("builder:navigation:reset", {
        bubbles: true,
        detail: {
          element: this
        }
      }));

    }

    _updateButtonStates() {

      /* ----- Capture all buttons to update. ----- */

      // Update the state of next/prev buttons based on current step validity
      const currentStep = this.currentStep;
      if (!currentStep) return;
      
      const nextStep = this.nextStep;
      const prevStep = this.prevStep;
      
      const substeps = currentStep.substeps;

      // Get all buttons (inside builder and in controls)

      const nextButtons = this.querySelectorAll('[data-action="next-step"]');
      const controlsNextButtons = this.controls?.querySelectorAll('[data-action="next-step"]') || [];
      const prevButtons = this.querySelectorAll('[data-action="prev-step"]');
      const controlsPrevButtons = this.controls?.querySelectorAll('[data-action="prev-step"]') || [];

      // Combine both sets of buttons
      const allNextButtons = [...nextButtons, ...controlsNextButtons];
      const allPrevButtons = [...prevButtons, ...controlsPrevButtons];

      /* ----- Logic ----- */

      // Determine if the next button should be enabled.
      // If the step has substeps, check the current substep's validity.
      // Otherwise, check the main step's validity and completeness.
      let nextValid = false;
      let prevValid = false;

      if (substeps) {
        
        const currentSubstep = substeps.currentSubstep;
        const nextSubstep = substeps.nextSubstep;
        const prevSubstep = substeps.prevSubstep;

        nextValid = currentSubstep.isLast && nextStep ? true : currentSubstep.canNavigateTo(nextSubstep);
        prevValid = currentSubstep.isLast && prevStep ? true : currentSubstep.canNavigateTo(prevSubstep);

      } else {

        nextValid = currentStep.canNavigateTo(nextStep);
        prevValid = currentStep.canNavigateTo(prevStep);

      }

      /* ----- Update Buttons ----- */

      allNextButtons.forEach(button => {
        if (nextValid) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
      });

      allPrevButtons.forEach(button => {
        if (prevValid) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
      });

    }

    checkForCompletion() {

      const complete = this.allStepsComplete();
      
      // Update summary step completion based on all steps
      if (this.summaryStep) {
        if (complete) {
          this.summaryStep.complete = true;
        } else {
          this.summaryStep.complete = false;
        }
      }

      // console.log(`Quiz Complete - ${complete}`);

    }

    getSelections() {
      return this.querySelectorAll(builderSelectors.selected);
    }

    getFinalSelections() {
      return this.querySelectorAll(builderSelectors.finalSelection);
    }

    getRandomSelections() {

      const steps = this.steps.steps;
      const selections = [];
      const randomSelections = [];
      const substepAdds = this.dataset.substepAdds || false;

      for (let s = 0; s < steps.length; s++) {

        const step = steps[s];
        const substeps = step.querySelectorAll(builderSelectors.elements.substeps.substep);
        const stepChoices = step.querySelectorAll(builderSelectors.choice);
        
        if (stepChoices.length === 0) {
          continue;
        }
        
        // Select a random choice

        if (substeps.length > 0 && substepAdds == true) {

          for (let t = 0; t < substeps.length; t++) {
            const substep = substeps[t];
            const substepChoices = substep.querySelectorAll(builderSelectors.choice);
            const choice = substepChoices[Math.floor(Math.random() * substepChoices.length)];
            if (choice) {
              randomSelections.push(choice);
            }
          }

        } else {
          
          const choice = stepChoices[Math.floor(Math.random() * stepChoices.length)];
          if (choice) {
            randomSelections.push(choice);
          }

        }

      }

      return randomSelections;

    }

    getVariantDataFromSelections() {

      const selections = this.getSelections();
      const variant3DSelections = Variant3DHelper.filterVariant3DOptions(selections);

      const variantData = [];

      if (!variant3DSelections || variant3DSelections.length === 0) {
        return;
      }

      for (let i = 0; i < variant3DSelections.length; i++) {
        const selection = variant3DSelections[i];
        const data = selection.dataset.variantData;
        if (data) {
          variantData.push(JSON.parse(data));
        }
      }

      // console.log(variantData);

      return variantData;


    }

    scrollToTop() {

      if (this.shouldScroll == true) {
        this.scrollIntoView({
          behavior: "smooth",   // or "auto"
          block: "center",      // "start", "center", "end", "nearest"
          inline: "nearest"     // for horizontal alignment
        });
      }

    }

    scrollUp() {

      if (this.shouldScroll == true) {
        this.stepsContainer.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }

    }

    resetScroll() {

      if (this.shouldScroll == true) {
        this.stepsContainer.scrollTo({
          top: 0,
          left: 0
        });
      }

    }

    

    /* ---------- Event Handlers ---------- */

    _onReady(event) {
      
    }

    _onClickStart(e) {
      this.steps.gotoStep(this.steps.startStep);
    }

    _onClickRestart(e) {
      this.reset();
      this.steps.gotoStep(this.steps.introStep, true);
    }

    _onClickPrevStep(e) {
      if (this.currentStep.substeps) {
        this.currentStep.substeps.prev();
      }
      else {
        this.steps.gotoStep(this.steps.prevStep);
      }
    }

    _onClickNextStep(e) {
      if (this.currentStep.substeps) {
        this.currentStep.substeps.next();
      }
      else {
        this.steps.gotoStep(this.steps.nextStep);
      }
    }

    _onClickGotoStep(e, options) {

      const button = e.target;
      const stepNumber = button.dataset.step;

      const resetSubsteps = button.hasAttribute(`data-substeps-goto-first`);

      const force = options?.force === true ? true : false;

      let canNavigate = false;

      let step;

      if (stepNumber) {
        step = this.steps.steps[Number(stepNumber)];
      }

      if (step) {

        // Only allow navigation to steps that are complete or the current step
        if (step.complete || step.current || force) {
          canNavigate = true;
        }

        if (canNavigate) {
          this.steps.gotoStep(step, force);
        }
      }

      if (resetSubsteps == true) {
        step.substeps?.gotoFirst(false);
      }

    }


    _onStepChangeStart(e) {

      // Fires after it's confirmed the step will progress.
      // Fires before the leave animation starts.

      const oldStep = e.detail.currentStep;
      const newStep = e.detail.nextStep;

      this.scrollToTop();

      if (this.currentStep.dataset.stepType != "summary") {
        this._onLeaveOrderSummary();
      }

    }

    _onStepChangeArrive(e) {

      // Fires after the leave animation ends.
      // Fires before the current step is registered.

      const oldStep = e.detail.currentStep;
      const newStep = e.detail.nextStep;

      oldStep.resetScroll();

      this.scrollToTop();

      // Mark the current step as complete if it's an info step (no selections required)
      if (newStep.isPlainStep && newStep.valid) {
        newStep.complete = true;
      }

      this.checkForCompletion();

    }

    _onStepChangeUpdated(e) {

      // Fires after the current step is registered..
      // Fires before the enter animation starts.

      const oldStep = e.detail.currentStep;
      const newStep = e.detail.nextStep;

      // Update the current step number to save state.
      this.updateCurrentStepNumber();

      // Update Navigation
      this.navigation?.refresh();

      // Info steps become valid when you enter them (no selection required)
      if (newStep.isPlainStep) {
        newStep.complete = true;
      }

      // Update button states.
      this._updateButtonStates();

      if (newStep.substeps) {
        // newStep.substeps.reset();
      }

      this.resetScroll();

    }

    _onStepChangeEnd(e) {

      // Fires after the enter animation ends.

      this.scrollIndicator.refresh();

      if (this.currentStep.dataset.stepType == "summary") {
        this._onArriveOrderSummary();
      }

    }

    // Substeps

    _onSubstepChangeUpdated(e) {

      // Update button states.
      this._updateButtonStates();
      this.resetScroll();

    }

    // Navigation

    _onNavigationRefresh(e) {
      this.navigation?.refresh();
    }

    _onNavigationReset(e) {
      this.navigation?.reset();
    }

    _onArriveOrderSummary() {
      this.orderSummary.build();
      this.orderSummary.in();
    }

    _onLeaveOrderSummary() {
      this.orderSummary.out();
    }

    /* ---------- Properties ---------- */


    /* --- Static --- */

    get sectionId() {
      return this.dataset.sectionId;
    }

    /* --- Dynamic --- */

    get property() {
      return this.getAttribute("property") === "true";
    }
    set property(value) {
      this.setAttribute("property", value ? "true" : "false");
    }

    /* ---------- Elements ---------- */

    get section() {
      return document.getElementById(this.sectionId);
    }

    // Steps

    get steps() {
      return this.querySelector("builder-steps");
    }
    get currentStep() {
      return this.querySelector("builder-step.builder-step--current");
    }
    get nextStep() {
      return this.currentStep.nextElementSibling;
    }
    get prevStep() {
      return this.currentStep.previousElementSibling;
    }
    
    // Components

    get controls() {
      const controlsId = `builder--${this.sectionId}-controls`;
      return document.getElementById(controlsId);
    }
    get navigation() {
      return this.querySelector(`builder-navigation`);
    }
    get summaryStep() {
      return this.querySelector('builder-step[data-step-type="summary"]');
    }
    get builderProduct() {
      try {
        return JSON.parse(this.dataset.builderProduct);
      } catch (e) {
        console.error('Error parsing builder product data:', e);
        return null;
      }
    }
    get scrollIndicator() {
      return this.querySelector(`builder-scroll-indicator`) || document.getElementById(this.dataset.scrollIndicator);
    }
    get stepsContainer() {
      return this.querySelector(`.builder-steps-container`);
    }
    get orderSummary() {
      return this.querySelector(`builder-order-summary`);
    }
    get tooltip() {
      return this.querySelector(`builder-tooltip`) || document.getElementById(this.dataset.tooltip);
    }

    // Labels

    get labelStepTotal() {
      return this.section.querySelectorAll(`[data-builder-label="step-total"]`);
    }
    get labelStepCurrent() {
      return this.section.querySelectorAll(`[data-builder-label="step-current"]`);
    }

    // Variant3D Viewer

    get viewer() {
      return this.querySelector(`builder-viewer`);
    }

    // Settings

    get settings() {

      let settings = {};

      settings.scrollOnStepChangeMobile = window.lightbuilder?.builder?.settings?.scrollOnStepChangeMobile || false;
      settings.scrollOnStepChangeDesktop = window.lightbuilder?.builder?.settings?.scrollOnStepChangeDesktop || false;

      return settings;

    }

    get shouldScroll() {
      if (!this.isOnMobile && this.settings.scrollOnStepChangeDesktop) {
        return true;
      }
      else
      if (this.isOnMobile && this.settings.scrollOnStepChangeMobile) {
        return true;
      }
    }

    get isOnMobile() {
      const onMobile = !window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches;
      return onMobile;
    }

  };

  var BuilderControls = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

    }

    /* ---------- Functions ---------- */

    _init() {

      const builder = this.builder;

      this.querySelector(`[data-action="prev-step"]`)?.addEventListener("click", this.builder._onClickPrevStep.bind(builder));
      this.querySelector(`[data-action="next-step"]`)?.addEventListener("click", this.builder._onClickNextStep.bind(builder));

    }

    /* ---------- Event Handlers ---------- */

    _onClickPrevStep(e) {
      this.builder.steps.gotoPrevStep();
    }

    _onClickNextStep(e) {
      this.builder.steps.gotoNextStep();
    }


    /* ---------- Properties ---------- */

    /* --- Static --- */

    get sectionId() {
      return this.dataset.sectionId;
    }

    /* --- Dynamic --- */


    /* ---------- Elements ---------- */

    get builder() {
      return document.getElementById(`builder--${ this.sectionId }`);
    }

  }

  var BuilderNavigation = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    /* ---------- Functions ---------- */

    _init() {

      const builder = this.builder;

      this._build();

      this.addEventListener('click', this._onNavigationItemClick.bind(this));

    }

    _onNavigationItemClick(event) {
      // Find the clicked navigation item
      const navigationItem = event.target.closest('builder-navigation-item');

      if (!navigationItem) {
        return;
      }

      // Get the associated step
      const step = navigationItem.step;

      if (!step) {
        return;
      }

      // Check if the step is valid before navigating
      if (step.current) {
        return;
      }

      // Check if the step is valid before navigating
      // 1. Step is valid.
      // 2. Step is complete.
      // 3. Previouss tep is valid or complete.
      if (step.valid || step.complete || navigationItem.previousElementSibling.step.complete) {
        this.builder.steps.gotoStep(step, true);
      }
    }

    _build() {

      // Remove all contents.

      this.innerHTML = "";

      // Build contents from steps.

      const steps = this.builder.steps.querySelectorAll("builder-step");

      let navigationHTML = "";

      let isComplete = false;
      let isValid = false;
      let isCurrent = false;
      let isSummary = false;

      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const stepShortTitle = step.dataset.titleShort;
        const stepNumber = step.dataset.stepNumber;

        if (!step.hasAttribute("data-navigation")) {
          continue;
        }

        let stepHTML = lightbuilder.templates.navigationItem;

        // Replace Variables in HTML String

        stepHTML = stepHTML.replaceAll("$STEP_SHORT_TITLE", stepShortTitle);
        stepHTML = stepHTML.replaceAll("$STEP_NUMBER", stepNumber);

        let fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = stepHTML;

        // Parse the HTML String
        
        let navigationItem = fakeDiv.querySelector(`builder-navigation-item`);

        // If this is a summary step, mark it as complete
        if (step.dataset.stepType === 'summary') {
          isSummary = true;
        }

        // Update the navigation element.

        if (isComplete) {
          navigationItem.classList.add("builder-navigation-item--complete");
        }

        if (isCurrent == true) {
          navigationItem.classList.add("builder-navigation-item--current");
        }

        if (isValid == true) {
          navigationItem.classList.add("builder-navigation-item--valid");
        }

        if (isSummary == true) {
          navigationItem.classList.add("builder-navigation-item--summary");
        }

        navigationHTML += fakeDiv.innerHTML;

      }


      this.innerHTML = navigationHTML;

      // Make first item active.
      this.querySelector("builder-navigation-item").classList.add("builder-navigation-item--current");

    }

    refresh() {

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const step = item.step;
        
        const stepValid = step.valid;
        const stepCurrent = step.current;
        const stepComplete = step.complete;

        item.current = stepCurrent;
        item.complete = stepComplete;
      }

    }

    reset() {

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const step = item.step;

        item.current = false;
        item.complete = false;
      }

    }

    /* ---------- Event Handlers ---------- */

    _onClickPrevStep(e) {
      this.builder.steps.gotoPrevStep();
    }

    _onClickNextStep(e) {
      this.builder.steps.gotoNextStep();
    }


    /* ---------- Properties ---------- */

    /* --- Static --- */

    get sectionId() {
      return this.dataset.sectionId;
    }

    get builderId() {
      return this.dataset.builder;
    }

    /* --- Dynamic --- */


    /* ---------- Elements ---------- */

    get items() {
      return this.querySelectorAll(`builder-navigation-item`);
    }

    get builder() {
      return document.getElementById(`${ this.builderId }`);
    }

  }

  var BuilderNavigationItem = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    /* ---------- Functions ---------- */

    _init() {

      

    }

    /* ---------- Attributes ---------- */

    get valid() {
      return this.classList.contains("builder-navigation-item--valid");
    }
    set valid(value = false) {
      if (typeof value != "boolean") {
        return;
      }
      if (value === true) {
        this.classList.add("builder-navigation-item--valid");
      }
      else {
        this.classList.remove("builder-navigation-item--valid");
      }
    }

    get current() {
      return this.classList.contains("builder-navigation-item--current");
    }
    set current(value = false) {
      if (typeof value != "boolean") {
        return;
      }
      if (value === true) {
        this.classList.add("builder-navigation-item--current");
      }
      else {
        this.classList.remove("builder-navigation-item--current");
      }
    }

    get complete() {
      return this.classList.contains("builder-navigation-item--complete");
    }
    set complete(value = false) {
      if (typeof value != "boolean") {
        return;
      }
      if (value === true) {
        this.classList.add("builder-navigation-item--complete");
      }
      else {
        this.classList.remove("builder-navigation-item--complete");
      }
    }

    /* ---------- Elements ---------- */

    get navigation() {
      return this.closest(`builder-navigation`);
    }

    get step() {
      return this.navigation.builder.querySelector(`builder-step[data-step-number="${this.dataset.step}"]`);
    }

  }

  var BuilderSteps = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

    }

    _init() {

      

    }

    /* ---------- Functions ---------- */

    async gotoStep(step, force = false) {

      /*
      Paramters:
      - step (BuilderStep) - step to navigate to.
      - force (boolean) - allow navigation to the step even if it would normally be prevented.
      */

      if (!step) {
        return;
      }

      const currentStep = this.currentStep;

      // Check if navigation to this step is allowed
      if (!currentStep.canNavigateTo(step) && !force) {
        return;
      }

      this.dispatchEvent(new CustomEvent("builder:steps:change:start", {
        bubbles: true,
        detail: {
          element: this,
          currentStep: currentStep,
          nextStep: step
        }
      }));

      await currentStep.out();

      this.dispatchEvent(new CustomEvent("builder:steps:change:arrive", {
        bubbles: true,
        detail: {
          element: this,
          currentStep: currentStep,
          nextStep: step
        }
      }));

      currentStep.current = false;
      step.current = true;

      this.dispatchEvent(new CustomEvent("builder:steps:change:updated", {
        bubbles: true,
        detail: {
          element: this,
          currentStep: currentStep,
          nextStep: step
        }
      }));

      await step.in();

      this.dispatchEvent(new CustomEvent("builder:steps:change:end", {
        bubbles: true,
        detail: {
          element: this,
          currentStep: currentStep,
          nextStep: step
        }
      }));

    }

    gotoNextStep() {
      const nextStep = this.nextStep;
      if (nextStep.checkValidity()) {
        this.gotoStep(this.nextStep);
      }
      else {

      }
    }

    gotoPrevStep() {
      this.gotoStep(this.prevStep);
    }

    /* ---------- Attributes ---------- */

    get totalStepsNumber() {
      return this.steps.length;
    }
    get currentStepNumber() {
      const steps = Array.from(this.steps);
      return steps.indexOf(this.currentStep) + 1;
    }

    get selectedVariantId() {
      return this.getAttribute(`data-selected-variant-id`);
    }
    set selectedVariantId(id) {
      if (id) {
        this.setAttribute(`data-selected-variant-id`, id);
      }
      else {
        this.removeAttribute(`data-selected-variant-id`);
      }
    }

    /* ---------- Elements ---------- */

    get builder() {
      return this.closest("builder-main");
    }
    get steps() {
      return this.querySelectorAll("builder-step");
    }
    get currentStep() {
      return this.querySelector(".builder-step--current");
    }
    get nextStep() {
      return this.currentStep.nextElementSibling;
    }
    get prevStep() {
      return this.currentStep.previousElementSibling;
    }
    get introStep() {
      return this.steps[0];
    }
    get startStep() {
      return this.steps[1];
    }
    get endStep() {
      return this.steps[this.steps.length - 1];
    }

  }

  var BuilderStep = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
      this._init();
    }

    connectedCallback() {

      

    }

    _init() {

      // Initialize step states
      const isFirstStep = !this.previousElementSibling;
      
      this.isMultistep = this.hasAttribute("data-multistep-parent");

      // Listen for card selection events
      this.addEventListener("builder:step:selected", this._onStepSelection.bind(this));

      // Only the first step is valid initially
      // All other steps start invalid until the previous step is completed
      this.complete = isFirstStep;

      if (this.stepToMultiply) {
        this.updateStepMultiplier();
      }

      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", this._designModeOnBlockSelect.bind(this));
      }

    }

    /* 
    ----- Multistep -----
    These functions contain the logic for multisteps, when several steps' selections combine together
    to give a selection.
    */

    updateMultistep(e) {

      console.log(`----- updateMultistep() -----`)

      const id = this.getAttribute(`data-multistep-id`);

      if (!id) {
        return;
      }

      const steps = this.builder.steps.querySelectorAll(`builder-step[data-multistep-id="${id}"]`);
      const parentStep = Array.from(steps).find(e => e.hasAttribute("data-multistep-parent")) ?? null;
      const optionSteps = Array.from(steps).filter(e => !e.hasAttribute("data-multistep-parent"));

      if (!optionSteps.length || !parentStep) {
        return;
      }

      const selections = []; 

      for (let s = 0; s < steps.length; s++) {
        const step = steps[s];
        const selection = step.querySelector(builderSelectors.finalSelection);
        if (selection) {
          selections.push(selection);
        }
      }
      
      const options = mapTitlesFromSteps(optionSteps);;

      if (selections.length != steps.length) {
        // If we don't have selections for all the steps, abort — we can't update the multistep.
        return;
      }

      /* ----- Update the Multistep ----- */

      console.log(`updateMultistep`);

      const parentSelection = parentStep.querySelector(builderSelectors.finalSelection);
      const parentProductData = parentSelection.getAttribute(`data-product-data`);
      const parentProductDataJson = parentProductData ? JSON.parse(parentProductData) : null;

      if (!parentProductDataJson) {
        return;
      }

      const parentVariantsData = parentProductDataJson.variants;
      const multistepSelectedVariant = getVariantFromOptions(parentVariantsData, options);

      parentStep.selectedVariantId = multistepSelectedVariant.id;



    }

    updateStepMultiplier(multiplier) {

      // Finds the step that this step's choice multiplies, and sets its multiplier attribute.

      if (!this.stepToMultiply) {
        return;
      }

      if (!multiplier) {
        multiplier = this.selection?.dataset?.multiplier;
      }

      if (multiplier) {
        // Update multiplier attribute on step.
        this.stepToMultiply.dataset.multiplier = multiplier;
      }


    }

    get multiplier() {

      // If the current selection has a multiplier, store it so it can be applied to the multiplied step.

      let multiplier = 1;
      return multiplier;
      
    }

    /* ---------- Event Handlers ---------- */

    _designModeOnBlockSelect(e) {
      if (this.builder.currentStep != this) {
        this.builder.steps.gotoStep(this, true);
      }
    }

    _onStepSelection(e) {

      // Fired when a selection is made on a step.

      const { element, step } = e.detail;

      // Only handle if this is the step being updated
      if (step !== this) {
        return;
      }

      // Check if cards are valid
      const selection = element;
      const selectionValid = selection.valid;
      const selectionVariantId = selection.getAttribute(`[data-variant-id]`);

      if (this.substeps) {

        // Step has substeps — update the current substep's validity,
        // but don't mark the main step valid/complete yet.
        const currentSubstep = this.substeps.currentSubstep;

        if (currentSubstep) {
          currentSubstep.complete = true;
        }

      } else {

        this.complete = selectionValid;

      }

      // If the element selects a variant, set the step's variant ID to that variant.
      if (selectionVariantId) {
        step.selectedVariantId = selectionVariantId;
      }

      if (this.type == "multistep" || this.type == "multistep-parent") {
        this.updateMultistep();
      }

      if (this.stepToMultiply) {
        this.updateStepMultiplier();
      }

      this.dispatchEvent(new CustomEvent("builder:navigation:refresh", {
        bubbles: true,
        detail: {
          element: this
        }
      }));

      this.builder.checkForCompletion();

      // Update button states
      this.builder._updateButtonStates();
    }


    /* ---------- Functions ---------- */

    async out(shouldAnimate = true) {
      
      // Animation
      const animation = bAnimate(this, 'leave');
      shouldAnimate ? animation.play() : animation.finish();

      await animation.finished;

      return animation.finished;

    }

    async in(shouldAnimate = true) {

      // Animation
      const animation = bAnimate(this, 'enter');
      shouldAnimate ? animation.play() : animation.finish();

      return animation.finished;

    }

    async _executeAnimation(animation, shouldAnimate) {
      this._pendingAnimations.push(animation);
      shouldAnimate ? animation.play() : animation.finish();
      return animation.finished;
    }

    validate() {

      let valid = this.checkValidity();

      if (valid) {
        this.dispatchEvent(new CustomEvent("builder:steps:validation:valid"));
      }
      else {
        this.dispatchEvent(new CustomEvent("builder:steps:validation:invalid"));
      }

    }

    checkValidity() {
      // Validate different step types according to their rules
      const stepType = this.dataset.stepType;

      // Info steps are always valid (no selections required)
      if (stepType === 'info') {
        return true;
      }

      // Summary step is only valid if all previous steps are complete
      if (stepType === 'summary') {
        return this.areAllPreviousStepsComplete();
      }

      // For other step types, check substeps and card containers
      const substeps = this.querySelectorAll("builder-substep");
      const cardContainers = this.querySelectorAll("builder-cards");

      let v = true;

      if (substeps.length > 0) {
        for (let s = 0; s < substeps.length; s++) {
          const substep = substeps[s];
          if (substep.valid === false) {
            v = false;
            break;
          }
        }
        return v;
      }

      if (cardContainers.length > 0) {
        for (let s = 0; s < cardContainers.length; s++) {
          const cardContainer = cardContainers[s];
          if (cardContainer.checkValidity() === false) {
            v = false;
            break;
          }
        }
        return v;
      }

      // If no substeps or card containers, step is valid by default
      return v;

    }

    areAllPreviousStepsComplete() {
      // Check if all previous steps are complete
      let currentElement = this.previousElementSibling;
      while (currentElement) {
        if (currentElement.tagName === 'BUILDER-STEP') {
          if (!currentElement.complete) {
            return false;
          }
        }
        currentElement = currentElement.previousElementSibling;
      }
      return true;
    }

    reset() {
      // Reset the step to its initial state
      const stepType = this.dataset.stepType;

      // Deselect all cards in this step
      const cards = this.querySelectorAll("builder-card");
      cards.forEach(card => {
        card.selected = false;
      });

      // Reset substeps if any
      const substeps = this.querySelectorAll("builder-substep");
      substeps?.forEach(substep => {
        substep.reset();
      });


      // Plain steps (info) should remain valid
      if (this === this.builder.steps.introStep) {
        this.complete = true;
      }
      else {
        this.complete = false;
      }

    }

    resetScroll() {
      
      this.scrollTo({
        top: 0,
        left: 0
      });

    }

    scrollUp() {
      
      this.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });

    }


    /* ---------- Attributes ---------- */

    get title() {
      return this.dataset.title;
    }

    get number() {
      return this.dataset.stepNumber;
    }

    get current() {
      return this.classList.contains("builder-step--current");
    }
    set current(value) {
      if (typeof value != "boolean") {
        return
      }
      if (value == true) {
        this.classList.add("builder-step--current");
      }
      else {
        this.classList.remove("builder-step--current");
      }
      this.dispatchEvent(new CustomEvent("builder:step:current", {
        bubbles: true,
        detail: {
          element: this,
          current: value
        }
      }));
    }

    get valid() {
      return this.checkValidity();
    }
    /*
    set valid(value) {
      if (typeof value != "boolean") {
        return;
      }
      if (value === true) {
        this.setAttribute("data-valid", "true");
        this.classList.add("builder-step--valid");
      }
      else {
        this.setAttribute("data-valid", "false");
        this.classList.remove("builder-step--valid");
      }
      this.dispatchEvent(new CustomEvent("builder:step:valid", {
        bubbles: true,
        detail: {
          element: this,
          valid: value
        }
      }));
    }
    */

    get complete() {
      return this.hasAttribute("data-complete") && this.getAttribute("data-complete") === "true";
    }
    set complete(value) {
      if (typeof value != "boolean") {
        return;
      }
      if (value === true) {
        this.setAttribute("data-complete", "true");
        this.classList.add("builder-step--complete");
      }
      else {
        this.setAttribute("data-complete", "false");
        this.classList.remove("builder-step--complete");
      }
      if (value == true) {
        this.dispatchEvent(new CustomEvent("builder:step:complete", {
          bubbles: true,
          detail: {
            element: this,
            complete: value
          }
        }));
      }
    }

    get isPlainStep() {
      const stepType = this.dataset.stepType;
      return stepType === 'info';
    }

    get type() {
      let type = "step";
      if (this.hasAttribute("data-multistep-id")) {
        type = "multistep";
        if (this.hasAttribute("data-multistep-parent")) {
          type = 'multistep-parent';
        }
      }
      return type;
    }

    canNavigateTo(targetStep) {
      // Check if navigation to this step is allowed from the current step
      // Allow navigation if:
      // 1. This step is complete (can navigate back to completed steps), OR
      // 2. From step is complete and this is the immediate next step
      if (!targetStep) {
        return false;
      }
      const currentStep = this.builder.currentStep;
      const isPrevStep = targetStep.previousElementSibling === currentStep;
      return targetStep.complete || (currentStep.complete && isPrevStep);
    }

    /* ---------- Elements ---------- */

    get navigationItem() {
      return this.builder.querySelector(`builder-navigation-item[data-step-number="${ this.number }"]`);
    }

    get selection() {
      return this.querySelector(builderSelectors.selected);
    }

    get substeps() {
      return this.querySelector('builder-substeps') || null;
    }
    get steps() {
      return this.closest('.builder-steps-container') || null;
    }

    get stepToMultiply() {

      // If this step choice contains a multiplier for a subsequent step, save the reference to the step it multiplies.

      const stepShortTitle = this.dataset.multiplierForStep;
      // const step = this.builder.querySelector(`builder-step[data-title-short="${stepShortTitle}"]`);
      const step = this.builder.querySelector(`builder-step[data-title-short="${stepShortTitle}"]`);

      return step;

    }

    get builderId() {
      return this.dataset.builder;
    }
    get builder() {
      if (this.closest(builderSelectors.elements.builder.tag)) {
        // If the element is inside a main-builder.builder element.
        return document.getElementById(`${this.builderId}`);
      }
      else
      if (this.builderId) {
        // If the element has the ID of a main-builder.builder element.
        const element = document.getElementById(`${this.builderId}`);
        if (element) {
          return element;
        }
      }
      else {
        return null;
      }
      
    }


  }



  var BuilderSubsteps = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

      this.addEventListener("builder:substeps:change:start", this._onSubstepChangeStart.bind(this));

    }

    _onSubstepChangeStart(e) {
      // console.log(`_onSubstepChangeStart`);
      // this.builder.scrollUp();
      this.builder.scrollToTop();
    }

    /* ---------- Functions ---------- */

    _init() {
      // Ensure the first substep is current and visible
      const first = this.substepElements[0];
      if (first) {
        first.current = true;
        first.hidden = false;
      }
    }

    reset() {

      const substeps = this.substepElements;
      const first = this.substepElements[0];

      for (let s = 0; s < substeps.length; s++) {
        const substep = substeps[s];
        first.complete = false;
        first.current = false;
      }

      if (first) {
        this.gotoSubstep(first, false);
      }

    }

    gotoFirst(shouldAnimate = true) {
      const first = this.substepElements[0];
      if (first) {
        this.gotoSubstep(first, shouldAnimate);
      }
    }

    /**
     * Go to a specific substep by index or element reference.
     */
    async gotoSubstep(target, shouldAnimate = true) {

      let nextSubstep;

      if (typeof target === 'number') {
        nextSubstep = this.substepElements[target];
      } else if (target instanceof HTMLElement) {
        nextSubstep = target;
      }

      if (!nextSubstep || nextSubstep === this.currentSubstep) {
        return;
      }

      const currentSubstep = this.currentSubstep;

      this.dispatchEvent(new CustomEvent('builder:substeps:change:start', {
        bubbles: true,
        detail: {
          substeps: this,
          currentSubstep: nextSubstep
        }
      }));

      // Animate out and unset current
      if (currentSubstep) {
        currentSubstep.current = false;
        await currentSubstep.out(shouldAnimate);
      }

      this.dispatchEvent(new CustomEvent('builder:substeps:change:arrive', {
        bubbles: true,
        detail: {
          substeps: this,
          currentSubstep: nextSubstep
        }
      }));

      // Set current and animate in
      nextSubstep.current = true;

      this.dispatchEvent(new CustomEvent('builder:substeps:change:updated', {
        bubbles: true,
        detail: {
          substeps: this,
          currentSubstep: nextSubstep
        }
      }));

      await nextSubstep.in(shouldAnimate);

      this.dispatchEvent(new CustomEvent('builder:substeps:change:end', {
        bubbles: true,
        detail: {
          substeps: this,
          currentSubstep: nextSubstep
        }
      }));

      this.dispatchEvent(new CustomEvent('builder:substeps:change', {
        bubbles: true,
        detail: {
          substeps: this,
          currentSubstep: nextSubstep
        }
      }));

    }

    next() {

      const currentSubstep = this.currentSubstep;

      if (!currentSubstep) return;

      // Current substep must be valid to progress
      if (!currentSubstep.valid) return;

      // Mark current as complete
      currentSubstep.complete = true;

      if (this.isOnLast) {
        // All substeps done — mark the parent step valid/complete and go to next main step
        this._onAllSubstepsComplete();
      } else {
        // Go to next substep
        const nextEl = this.nextSubstep;
        if (nextEl) {
          this.gotoSubstep(nextEl);
        }
      }

    }

    /**
     * Go back to the previous substep.
     * If on the first substep, go to the previous main step.
     */
    prev() {

      if (this.isOnFirst) {
        // Go to previous main step
        const step = this.step;
        if (step) {
          step.builder.steps.gotoPrevStep();
        }
      } else {
        const prevEl = this.prevSubstep;
        if (prevEl) {
          this.gotoSubstep(prevEl);
        }
      }

    }

    /**
     * Check if all substeps are valid and complete.
     */
    allComplete() {
      return Array.from(this.substepElements).every(s => s.valid && s.complete);
    }

    /**
     * Called when the last substep is completed.
     * Marks the parent step as valid/complete and progresses to the next main step.
     */
    _onAllSubstepsComplete() {

      const step = this.step;

      if (step) {
        step.complete = true;

        // Refresh navigation and button states
        step.dispatchEvent(new CustomEvent('builder:navigation:refresh', {
          bubbles: true,
          detail: { element: step }
        }));

        step.builder?.checkForCompletion();
        step.builder?._updateButtonStates();

        // Progress to the next main step
        step.builder?.steps.gotoNextStep();
      }

    }

    _updateNavigation() {

      const nav = this.navigation;

      if (!nav) return;

      const navItems = nav.querySelectorAll('builder-substep-nav-item');
      const substeps = this.substepElements;

      navItems.forEach((item, index) => {
        const substep = substeps[index];
        if (!substep) return;

        item.classList.toggle('builder-substep-nav-item--active', substep.current);
        item.classList.toggle('builder-substep-nav-item--complete', substep.complete);
        item.classList.toggle('builder-substep-nav-item--valid', substep.valid);
      });

    }

    /* ---------- Elements ---------- */

    get navigation() {
      return this.querySelector('builder-substep-nav');
    }

    get substepElements() {
      return this.querySelectorAll('builder-substep');
    }

    get currentSubstep() {
      return this.querySelector('builder-substep[data-current="true"]');
    }

    get nextSubstep() {
      const current = this.currentSubstep;
      if (!current) return null;
      const next = current.nextElementSibling;
      return (next && next.tagName === 'BUILDER-SUBSTEP') ? next : null;
    }

    get prevSubstep() {
      const current = this.currentSubstep;
      if (!current) return null;
      const prev = current.previousElementSibling;
      return (prev && prev.tagName === 'BUILDER-SUBSTEP') ? prev : null;
    }

    get isOnFirst() {
      const current = this.currentSubstep;
      return current === this.substepElements[0];
    }

    get isOnLast() {
      const current = this.currentSubstep;
      const all = this.substepElements;
      return current === all[all.length - 1];
    }

    get step() {
      return this.closest('builder-step');
    }

    get builder() {
      const id = this.dataset.builderId;
      let builder;
      if (id) {
        builder = document.getElementById(id);
      }
      else {
        builder = this.closest('builder-main');
      }
      return builder;
    }


  }

  var BuilderSubstep = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
      this._init();
    }

    connectedCallback() {


    }

    /* ---------- Functions ---------- */

    _init() {
      // First substep starts as current and visible
      const isFirst = this.isFirst;
      this.current = isFirst;
      this.hidden = isFirst;
    }

    checkValidity() {

      let v = false;

      const selection = this.querySelector(builderSelectors.selected);

      if (selection) {
        v = true;
      }

      return v;

    }

    canNavigateTo(targetSubstep, force) {
      if (!targetSubstep) {
        return false;
      }
      const currentSubstep = this.parentSubsteps.currentSubstep;
      const isPrevStep = targetSubstep.previousElementSibling === currentSubstep;
      return targetSubstep.complete || (currentSubstep.valid && isPrevStep) || force;
    }

    reset() {
      this.complete = false;
    }

    async out(shouldAnimate = true) {

      const animation = bAnimate(this, 'leave');
      shouldAnimate ? animation.play() : animation.finish();

      await animation.finished;

      this.hidden = true;

      return animation.finished;

    }

    async in(shouldAnimate = true) {

      this.hidden = false;

      const animation = bAnimate(this, 'enter');
      shouldAnimate ? animation.play() : animation.finish();

      return animation.finished;

    }

    /* ---------- Properties ---------- */

    get isFirst() {
      return (!this.previousElementSibling || this.previousElementSibling.tagName !== 'builder-substep');
    }
    get isLast() {
      return (!this.nextElementSibling || this.nextElementSibling.tagName !== 'builder-substep');
    }

    get valid() {
      return this.checkValidity();
    }

    get complete() {
      return this.hasAttribute('data-complete') && this.getAttribute('data-complete') === 'true';
    }
    set complete(value) {
      if (typeof value !== 'boolean') return;
      this.setAttribute('data-complete', value ? 'true' : 'false');
      this.classList.toggle('builder-substep--complete', value);
    }

    get current() {
      return this.hasAttribute('data-current') && this.getAttribute('data-current') === 'true';
    }
    set current(value) {
      if (typeof value !== 'boolean') return;
      this.setAttribute('data-current', value ? 'true' : 'false');
      this.classList.toggle('builder-substep--current', value);
    }

    /* ---------- Elements ---------- */

    get step() {
      return this.closest('builder-step');
    }

    get parentSubsteps() {
      return this.closest('builder-substeps');
    }

  }


  var BuilderScrollIndicator = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

    }

    _init() {

      window.addEventListener("orientationchange", this._onResize.bind(this));
      window.addEventListener("resize", this._onResize.bind(this));

    }

    /* ---------- Functions ---------- */

    _onResize() {
      this.refresh();
    }

    refresh() {
      
      if (isScrollable(this.builder.stepsContainer)) {
        this.show();
      } else {
        this.hide();
      }

    }

    show() {
      this.classList.add(`scroll-indicator--visible`);
    }

    hide() {
      this.classList.remove(`scroll-indicator--visible`);
    }
    
    /* ---------- Elements ---------- */

    get builder() {
      return document.getElementById(this.dataset.builder);
    }


  }

  var BuilderTooltip = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
      this._init();
    }

    _init() {

      // this.builder.addEventListener("builder:tooltip:attention", this.attention.bind(this));
      // this.builder.addEventListener("builder:tooltip:show", this.show.bind(this));
      // this.builder.addEventListener("builder:tooltip:hide", this.hide.bind(this));

      this.builder.addEventListener("builder:substeps:change:start", this.onLeave.bind(this));
      this.builder.addEventListener("builder:substeps:change:updated", this.onArrive.bind(this));

      this.builder.addEventListener("builder:steps:change:start", this.onLeave.bind(this));
      this.builder.addEventListener("builder:steps:change:updated", this.onArrive.bind(this));

      this.builder.addEventListener("builder:step:selected", this.onSelection.bind(this));

      // this.reset();

    }

    /* ---------- Functions ---------- */

    updateText(text) {
      if (typeof text == "string" && text) {
        this.message = text;
      }
      else {
        this.message = "";
      }
    }

    getMessageFromStep(step, messageType) {

      if (!step) {
        return;
      }

      const hasSubsteps = step.substeps ? true : false;

      let stepType = step.dataset.stepType;

      if (stepType == "info" && step == step.builder.steps.introStep) {
        stepType = "intro";
      }
      else
      if (stepType == "info") {
        return;
      }
      
      const stepComplete = step.complete;
      const stepValid = step.valid;
      const stepCopy = window.lightbuilder.copy.steps[stepType];
      const stepDefaults = window.lightbuilder.copy.steps.general;

      const choiceSteps = ["option", "collection", "product", "product_in_collection"];
      
      const selection = hasSubsteps ? step.substeps.currentSubstep.querySelector(builderSelectors.selected) : step.querySelector(builderSelectors.selected);

      if (!messageType) {
        if (stepValid === true) {
          messageType = "valid"
        } 
        else
        if (stepValid === false) {
          messageType = "invalid"
        }
      }

      let message = stepCopy[messageType] || "";

      if (typeof message == "undefined" || message === "") {
        return;
      }

      /* ----- Transform Text ----- */

      const itemType = step.substeps?.currentSubstep.getAttribute(`data-item-type`) || step.getAttribute('data-item-type');

      let selectionName = selection?.dataset.title;
      selectionName = selectionName?.replaceAll(" / ", ", ");

      if (message.indexOf("$TEXT_STEP_ITEM_NAME") != -1 && selectionName) {
        message = message.replace("$TEXT_STEP_ITEM_NAME", selectionName);
      }
      if (message.indexOf("$TEXT_STEP_ITEM_TYPE") != -1 && itemType) {
        message = message.replace("$TEXT_STEP_ITEM_TYPE", itemType);
      }

      /* ----- Defaults ----- */

      if (message.indexOf("$TEXT_STEP_") != -1) {
        if (stepDefaults[messageType] == "") {
          if (choiceSteps.includes(stepType)) {
            messageType = "choose_an_item"
          }
        }
        message = stepDefaults[messageType];
      }

      return message;
      
    }

    get animationClasses() {
      return [
        "builder-tooltip--attention",
        "builder-tooltip--pulse",
        "builder-tooltip--in",
        "builder-tooltip--out"
      ];
    }

    get stateClasses() {
      return [
        "builder-tooltip--primary", 
        "builder-tooltip--secondary", 
        "builder-tooltip--success", 
        "builder-tooltip--warning", 
        "builder-tooltip--danger"
      ];
    }

    async attention() {
      
      // this.classList.remove(`builder-tooltip--attention`);
      this.classList.remove(...this.animationClasses);
      this.classList.add(`builder-tooltip--attention`);
      // await new Promise(resolve => setTimeout(resolve, 800));
      // this.classList.remove(`builder-tooltip--attention`);
      
    }

    async pulse() {
      // this.classList.remove(`builder-tooltip--pulse`);
      this.classList.remove(...this.animationClasses);
      this.classList.add(`builder-tooltip--pulse`);
      await new Promise(resolve => setTimeout(resolve, 800));
      this.classList.remove(`builder-tooltip--pulse`);
    }

    async in() {
      // this.classList.remove(`builder-tooltip--in`);
      this.classList.remove(...this.animationClasses);
      this.classList.add(`builder-tooltip--in`);
      await new Promise(resolve => setTimeout(resolve, 500));
      this.classList.remove(`builder-tooltip--in`);
    }

    async out() {
      // this.classList.remove(`builder-tooltip--out`);
      this.classList.remove(...this.stateClasses);
      this.classList.remove(...this.animationClasses);
      this.classList.add(`builder-tooltip--out`);
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    /* Event Handlers ---------- */

    onSelection() {

      let message;

      const currentStep = this.builder.currentStep;
      // const currentSelection = currentStep.selection;
      
      let state;

      if (currentStep.checkValidity()) {
        message = this.getMessageFromStep(currentStep, "valid");
        state = "primary";
        // this.pulse();
      }
      else {
        message = this.getMessageFromStep(currentStep, "default");
        state = "danger";
        this.attention();
      }

      if (!message) {
        return;
      }

      this.state = state;
      this.message = message;

    }

    onArrive() {

      const currentStep = this.builder.currentStep;
      const currentSelection = currentStep.selection;

      let message;
      let state;

      if (currentSelection) {
        message = this.getMessageFromStep(currentStep, "valid");
        state = "primary";
      }
      else {
        message = this.getMessageFromStep(currentStep, "default");
        state = "secondary";
      }
      
      if (!message) {
        return;
      }

      this.state = state;
      this.message = message;

      this.show();

    }

    onLeave() {

      this.hide();

    }


    async show(shouldAnimate = true) {
      if (this.message == "") {
        return;
      }
      if (shouldAnimate) {
        await this.in();
      }
    }

    async hide(shouldAnimate = true) {
      if (shouldAnimate) {
        await this.out();
      }
    }

    /* ---------- Properties ---------- */

    set state(state) {

      if (!this.states.includes(state)) {
        state = "default";
      }

      this.dataset.state = state;

      // Visual

      for (const state of this.states) {
        this.classList.remove(`builder-tooltip--${state}`);
      }

      this.classList.add(`builder-tooltip--${state}`);

    }

    get state() {
      return this.dataset.state || "default";
    }

    get message() {
      return this.labelText.innerHTML;
    }
    set message(text) {
      this.labelText.innerHTML = text;
    }
    
    get states() {
      return [
        'default',
        'primary',
        'secondary',
        'success',
        'warning',
        'danger'
      ]
    }

    /* ---------- Elements ---------- */

    get labelText() {
      return this.querySelector(`[data-builder-tooltip-text]`);
    }
    get builder() {
      return this.closest("builder-main") || document.getElementById(this.dataset.builder);
    }

  }


  var BuilderCards = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this.addEventListener("builder-cards:ready", this._onReady.bind(this));
      this.addEventListener("builder-card:selected", this._onCardSelected.bind(this));

      this._init();

    }

    _init() {

    }


    /* ---------- Functions ---------- */

    checkValidity() {
      
      const cards = this.querySelectorAll("builder-card");
      const selectedCard = this.querySelector(builderSelectors.elements.cards.selected);
      
      let cardsValid = false;

      if (cards) {
        cardsValid = false;
      }

      if (selectedCard) {
        cardsValid = true;
      }

      return cardsValid;

    }

    clear() {
      this.selectedCards.forEach((el) => {
        el.selected = false;
      });
    }

    
    /* ---------- Event Handlers ---------- */

    _onReady(event) {

    }

    _onCardSelected(event) {

      const selected = event?.detail?.selected;

      this.dispatchEvent(new CustomEvent(`builder:step:selected`, {
        bubbles: true,
        detail: {
          element: this,
          step: this.step
        }
      }));

      if (event.detail.element.autoprogress) {
        if (this.step.substeps) {
          this.step.substeps.next();
        }
        else {
          this.step.builder.steps.gotoNextStep();
        }
      }

    }


    /* ---------- Elements ---------- */

    get selectedCards () {
      return this.querySelectorAll(builderSelectors.elements.cards.selected);
    }

    get step() {
      return this.closest("builder-step");
    }


    /* ---------- Properties ---------- */

    get limit() {
      return Number(this.dataset.limit);
    }

    get minimum() {
      return Number(this.dataset.limit);
    }

    get valid() {
      return this.checkValidity();
    }

  }


  var BuilderCard = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

    }

    _init() {

      this.addEventListener("builder-card:ready", this._onReady.bind(this));
      this.addEventListener("click", this._onClick.bind(this));

      this.querySelectorAll(`.builder-card__actions button`).forEach((el) => {
        el.addEventListener("click", this._onClickAction.bind(this));
      });

      this.dispatchEvent(new CustomEvent("builder-card:ready", {
        bubbles: true,
        detail: {
          element: this
        }
      }));

    }

    /* ---------- Functions ---------- */

    

    /* ---------- Event Handlers ---------- */

    _onReady(event) {
      
    }

    _onClick(event) {

      if (this.selected === false) {
        if (this.parentCards.limit === 1) {
          this.parentCards.clear();
          this.selected = true;
        }
        else if (this.parentCards.selectedCards.length < this.parentCards.limit) {
          this.selected = true;
        }
      }
      else {
        this.selected = false;
      }

      if (this.elementToActivate) {
        if (this.selected) {
          this.deactivateSiblings();
          this.elementToActivate.active = this.selected;
        }
        else {
          this.deactivateSiblings();
        }
        
      }

      const selectedClass = BuilderHelper.selectorToClass(builderSelectors.elements.cards.selected);

      if (this.classList.contains(selectedClass)) {
        this.dispatchEvent(new CustomEvent("viewer:update", {
          bubbles: true,
          detail: {
            element: this
          }
        }));        
      }

      this.dispatchEvent(new CustomEvent("builder-card:selected", {
        bubbles: true,
        detail: {
          element: this,
          selected: this.selected
        }
      }));

    }

    _onClickAction(event) {
      event.stopPropagation();
    }

    deactivateSiblings() {
      for (let s = 0; s < this.siblingCards.length; s++) {
        const sibling = this.siblingCards[s];
        if (sibling.elementToActivate) {
          sibling.elementToActivate.active = false;
        }
      }
    }

    /* ---------- Elements ---------- */

    get parentCards() {
      return this.closest("builder-cards");
    }

    get siblingCards() {
      return this.parentCards.querySelectorAll(".builder-card");
    }

    get elementToActivate() {
      return document.getElementById(`${ this.dataset.builderActivates }`);
    }

    /* ---------- Properties ---------- */


    get selected() {
      const selector = builderSelectors.elements.cards.selected;
      const className = BuilderHelper.selectorToClass(selector);
      return this.classList.contains(className) === true;
    }
    set selected(value) {
      const selector = builderSelectors.elements.cards.selected;
      const className = BuilderHelper.selectorToClass(selector);
      if (value === true && this.selected === false) {
        this.classList.add(className);
      }
      else {
        this.classList.remove(className);
      }
    }

    get builderId() {
      return this.dataset.builder;
    }
    get builder() {
      return this.closest("builder-main") || document.getElementById(this.dataset.builder);
    }
    get autoprogress() {
      return this.hasAttribute("data-auto-progress");
    }

    get productData() {
      const scriptTag = this.querySelector('script[data-product]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

    get variantData() {
      const scriptTag = this.querySelector('script[data-variant]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

    get variantsData() {
      const scriptTag = this.querySelector('script[data-variants]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

  };

  var BuilderProductStep = class extends HTMLElement {

    constructor() {
      super();
      this._init();
    }

    _init() {

      this.optionButtons = this.querySelectorAll('[data-option-value]')
      this.options = this.querySelectorAll('.builder-product-option');

      this.optionButtons.forEach(button => {
        button.addEventListener('click', this._onClickOption.bind(this));
      });

      this.reset(); 

      this.productId = this.dataset.productId;
      this.selectFirstAvailableOptions();
      this.updateVariant();
      
    }

    reset() {

      this.productId = null;
      this.selectedOptions = {};
      this.basePrice = null;
      this.selectedVariant = null;

    }

    

    updateVariant(variant) {

      const step = this.closest(`builder-step`);
      const substep = this.closest(`builder-substep`);

      if (!variant) {
        variant = getVariantFromOptions(this.variantsData, this.selectedOptions);
      }

      if (!variant) {

        this.step.removeAttribute('data-title');
        this.substep?.setAttribute('data-title', productTitle);

        delete this.dataset.price;
        delete this.dataset.priceCompare;
        delete this.dataset.variantId;
        delete this.dataset.variantTitle;
        delete this.dataset.title;
        
        delete this.step.dataset.variantId;

        return;

      }

      this.selectedVariant = variant;
      this.selectedVariantId = step.selectedVariantId = variant.id;

      // const animLeave = bAnimate(this.productImage.parentElement, 'blinkOut');
      // shouldAnimate ? animLeave.play() : animLeave.finish();
      // await animLeave.finished;

      // Prices

      let price;
      let priceCompare;

      price = variant.price;
      priceCompare = variant.compare_at_price;

      /* ----- Trade Discount ----- */
      let tradeDiscount = 1 - (window.themeVariables.settings.trade_discount / 100);
      if (this.tradeDiscounted) {
        priceCompare = price;
        price = price * tradeDiscount;
      }

      let displayPrice = formatMoney(price);
      let displayPriceCompare = formatMoney(priceCompare);

      this.labelPrice.innerHTML = displayPrice;
      this.labelPriceCompare.innerHTML = displayPriceCompare;

      if (priceCompare === price || priceCompare === null) {
        this.labelPriceCompare.closest('.price').setAttribute('hidden', "");
      }
      else {
        this.labelPriceCompare.closest('.price').removeAttribute('hidden');
      }

      this.updateTags();

      const productTitle = trimBuilderPrefix(this.productData.title);

      // Data for OrderSummary

      // Store the raw (undiscounted) variant price and title on the element
      // so the order summary can read them later.
      this.dataset.price = price;
      this.dataset.priceCompare = priceCompare;
      this.dataset.variantId = variant.id;
      this.dataset.variantTitle = variant.title;
      this.dataset.title = variant.title || productTitle || this.productData.title;

      // Image

      const caption = variant.title.replaceAll(" / ", ", ");

      this.querySelector(`[data-variant-title]`).innerHTML = caption;

      if (variant.featured_image?.src) {
        this.productImage.src = variant.featured_image.src;
        this.productImage.alt = variant.featured_image.alt || this.productData.title;  
        this.querySelector(`[data-image-disclaimer]`).style.visibility = 'hidden';
      }
      else {
        this.productImage.src = this.productData.media[0].preview_image.src;
        this.productImage.alt = this.productData.media[0].alt;
        this.querySelector(`[data-image-disclaimer]`).style.visibility = 'visible';
      }

      // const animEnter = bAnimate(this.productImage.parentElement, 'blinkIn');
      // shouldAnimate ? animEnter.play() : animEnter.finish();
      // await animEnter.finished;

      // console.log(this);
      // console.log(this.dataset.variantId);
      // console.log(variant);

    }

    updateTags() {
      
      let showTags = false;
      let html = "";
      let tagsDiv = document.createElement('div');

      if (this.tradeDiscounted) {
        
        let tagHTML = window.lightbuilder.templates.tag;
        let tagDiv = document.createElement('div');

        tagDiv.innerHTML = tagHTML;

        let tag = tagDiv.querySelector(`.label`);

        tag.innerText = window.lightbuilder.copy.trade.trade_discount;
        tag.classList.remove(`$CLASSES`);
        tag.classList.add(`label--custom`);

        html += tagDiv.innerHTML;

      }

      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // DOM Manipulation

      // Show/Hide Container

      if (html != "") {
        this.containerTags.innerHtml = tempDiv.innerHTML;
        this.containerTags.removeAttribute('hidden');
      }
      else {
        this.containerTags.setAttribute('hidden', "");
      }

    }

    checkValidity() {

      const totalOptions = this.querySelectorAll('.builder-product-option').length;
      const selectedCount = Object.keys(this.selectedOptions).length;

      return (selectedCount === totalOptions && this.selectedVariantId != null);

    }

    checkAllSelected() {

      if (this.checkValidity()) {

        const variant = getVariantFromOptions(this.variantsData, this.selectedOptions);

        // All options selected - step is complete.
        this.complete = true;

      }
      else
      {

        // Not all options selected - step is not complete.
        this.complete = false;
        this.selectedVariantId = null;

        delete this.dataset.price;
        delete this.dataset.priceCompare;
        delete this.dataset.id;
        delete this.dataset.title;

      }

    }

    /* ---------- Event Handlers ---------- */

    _onClickOption(event) {

      const button = event.currentTarget;
      
      if (button.disabled) return;

      const position = button.dataset.optionPosition;
      const value = button.dataset.optionValue;
      // const price = parseInt(button.dataset.variantPrice);

      this.selectOption(position, value);
      this.updateVariant();

      if (Variant3DHelper.hasVariant3DProperties(this)) {
        if (this.selectedVariant) {
          this._updateVariant3DProperties(this.selectedVariant);
        }
      }

      // Check if all options selected
      this.checkAllSelected();

      this.dispatchEvent(new CustomEvent(`builder:step:selected`, {
        bubbles: true,
        detail: {
          element: this,
          step: this.step
        }
      }));

    }

    /* ---------- Functions ---------- */

    _updateVariant3DProperties(variant) {

      console.log(`_updateVariant3DProperties`);

      // Update the 3D model viewer with the variant's 3D properties

      if (!variant) {
        return;
      }

      const metafieldsNode = this.querySelector(`variant-metafields[data-variant-id="${variant.id}"]`);

      const element = this;

      // const meshesDefault = this.dataset.variant3dMeshesDefault;
      // const materialsDefault = this.dataset.variant3dMaterialsDefault;
      // const meshExclusionsDefault = this.dataset.variant3dMeshExclusionsDefault;

      let variantMeshes;
      let variantMaterials;
      let variantMeshExclusions;
      let variantGroup1Meshes;
      let variantGroup1Materials;
      let variantGroup2Meshes;
      let variantGroup2Materials;
      let variantGroup3Meshes;
      let variantGroup3Materials;

      if (metafieldsNode) {

        variantMeshes = this.formatVariant3DData(metafieldsNode.dataset.variant3dMeshes);
        variantMaterials = this.formatVariant3DData(metafieldsNode.dataset.variant3dMaterials);
        variantMeshExclusions = this.formatVariant3DData(metafieldsNode.dataset.variant3dMeshExclusions);
        variantGroup1Meshes = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup1Meshes);
        variantGroup1Materials = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup1Materials);
        variantGroup2Meshes = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup2Meshes);
        variantGroup2Materials = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup2Materials);
        variantGroup3Meshes = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup3Meshes);
        variantGroup3Materials = this.formatVariant3DData(metafieldsNode.dataset.variant3dGroup3Materials);

      }

      if (variantMeshes) this.dataset.variant3dMeshes = variantMeshes;
      else delete this.dataset.variant3dMeshes;

      if (variantMaterials) this.dataset.variant3dMaterials = variantMaterials;
      else delete this.dataset.variant3dMaterials;

      if (variantMeshExclusions) this.dataset.variant3dMeshExclusions = variantMeshExclusions;
      else delete this.dataset.variant3dMeshExclusions;

      if (variantGroup1Meshes) {
        this.dataset.variant3dGroup1Meshes = variantGroup1Meshes;
        if (variantGroup1Materials) {
          this.dataset.variant3dGroup1Materials = variantGroup1Materials;
        }
        else {
          delete this.dataset.variant3dGroup1Materials;
        }
      }

      if (variantGroup2Meshes) {
        this.dataset.variant3dGroup2Meshes = variantGroup2Meshes;
        if (variantGroup2Materials) {
          this.dataset.variant3dGroup2Materials = variantGroup2Materials;
        }
        else {
          delete this.dataset.variant3dGroup2Materials;
        }
      }

      if (variantGroup3Meshes) {
        this.dataset.variant3dGroup3Meshes = variantGroup3Meshes;
        if (variantGroup3Materials) {
          this.dataset.variant3dGroup3Materials = variantGroup3Materials;
        }
        else {
          delete this.dataset.variant3dGroup3Materials;
        }
      }

      this.builder.dispatchEvent(new CustomEvent("viewer:update", {
        bubbles: true,
        detail: {
          element: this
        }
      }));

    }

    formatVariant3DData(json) {
      const str = typeof json === 'string' ? json : JSON.stringify(json);
      // const formatted = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      const formatted = str;
      return formatted;
    }

    async selectOption(position, value, isInitial = false) {

      console.log(`selectOption`);

      this.selectedOptions[position] = value;

      // Update UI
      const optionContainer = this.querySelector(`[data-option-position="${position}"]`);
      if (!optionContainer) return;

      // Update selected state
      const allButtons = optionContainer.querySelectorAll('[data-option-value]');

      for (let i = 0; i < allButtons.length; i++) {
        const btn = allButtons[i];
        const isSelected = btn.dataset.optionValue === value;

        btn.classList.toggle('block-swatch--selected', isSelected && btn.classList.contains('block-swatch'));
      }
      
      // Update value label
      const valueLabel = this.querySelector(`#product-${this.productId}-option-${position}-value`);
      if (valueLabel) {
        valueLabel.textContent = value;
      }

    }

    selectFirstAvailableOptions() {

      this.options.forEach(option => {

        const firstAvailable = option.querySelector('[data-option-value]:not([disabled])');

        if (firstAvailable) {
          const position = firstAvailable.dataset.optionPosition;
          const value = firstAvailable.dataset.optionValue;
          const price = parseInt(firstAvailable.dataset.variantPrice);

          this.selectOption(position, value, true);

        }

      });

    }

    /* ----- Elements ----- */

    get labelPrice() {
      return this.querySelector(`[data-price-label]`);
    }
    get labelPriceCompare() {
      return this.querySelector(`[data-price-compare-label]`);
    }
    get containerTags() {
      return this.querySelector(`[data-tags]`);
    }
    get tradeDiscounted() {
      return this.hasAttribute(`data-trade-discount`);
    }
    get productImage() {
      return this.querySelector(`.builder-product-step__image img`);
    }
    get builder() {
      return this.closest("builder-main") || document.getElementById(this.dataset.builder);
    }
    get step() {
      return this.closest(`builder-step`);
    }
    
    get selectedVariantId() {
      return this.dataset.variantId;
    }
    set selectedVariantId(id) {
      this.dataset.variantId = id;
    }

    get complete() {
      return this.classList.contains("builder-product-step--complete");
    }
    set complete(boolean) {
      this.classList.toggle("builder-product-step--complete", boolean);
    }

    get active() {
      return this.classList.contains("builder-product-step--active");
    }
    set active(boolean) {
      this.classList.toggle("builder-product-step--active", boolean);
    }

    get valid() {
      return this.checkValidity();
    }

    get productData() {
      const scriptTag = this.querySelector('script[data-product]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

    get variantData() {
      const scriptTag = this.querySelector('script[data-variant]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

    get variantsData() {
      const scriptTag = this.querySelector('script[data-variants]');
      if (!scriptTag) {
        return;
      }
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('BuilderProductStep: Error parsing variant data', e);
      }
    }

  }


  var BuilderOrderSummary = class extends CustomHTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {

      this._init();

    }

    _init() {

      this.form?.addEventListener("submit", this._onFormSubmit.bind(this));

      this.delegate.on("click", `[data-action="goto-step"]`, (event) => {
        const options = { force: true }
        this.builder._onClickGotoStep(event, options);
      });

      this.delegate.on("change", `.builder-order-summary__addon-checkbox`, (event) => {
        this.updateTotal();
      });

    }

    /* ---------- Functions ---------- */

    reset() {

    }

    getStepProductData(step) {

      if (!step) {
        return;
      }

      const selection = step.querySelector(builderSelectors.selected);
      const data = JSON.parse(selection.dataset.productData);

      return data;
      
    }

    build() {

      const steps = Array.from(this.builder.steps.steps);

      let html = ``;

      this.table.innerHTML = ``;

      // Values to update after table has been built.
      let tablePriceTotal = 0;

      for (let i = 0; i < steps.length; i++) {
        
        const step = steps[i];

        const multistepParent = step.hasAttribute("data-multistep-parent");

        const selection = step.querySelector(builderSelectors.finalSelection);

        let hasSelection = selection ? true : false;

        let multisteps;
        let multistepOptions;
        let multistepProductData;
        let multistepSelectedVariant;

        if (multistepParent && selection) {

          const multistepId = step.getAttribute("data-multistep-id");

          const stepProductData = this.getStepProductData(step);
          const productOptions = stepProductData.options;
          const productVariants = stepProductData.variants;

          multisteps = steps.filter(el => {
            return el.getAttribute('data-multistep-id') === multistepId;
          });

          const multistepsOptions = multisteps.filter(el => !el.hasAttribute('data-multistep-parent'));
          const multistepOptionValues = getSelectionTitlesFromSteps(multistepsOptions);

          multistepSelectedVariant = findVariantByOptions(productVariants, multistepOptionValues);

        }

        if (step.hasAttribute(`data-summary`)) {

          const stepTitle = step.dataset.title;
          const stepNumber = Number(step.dataset.stepNumber);
          const stepTitleShort = step.dataset.titleShort;
          const stepSummaryName = step.dataset.summaryName;
          const stepType = step.dataset.stepType;

          // Selection Info
          
          const selectionVariantId = Number(step.dataset.variantId) || Number(selection?.dataset.variantId) || "";

          if (hasSelection) {

            let productData = selection.productData;
            let variantsData = selection.variantsData;
            let variantData = multistepSelectedVariant || variantsData?.find(variant => variant?.id === selectionVariantId);

            const selectionTrade = selection.hasAttribute('data-trade-discount');

            const selectionMultiplier = Number(selection?.closest(`builder-step`).dataset.multiplier) || 1;
            const selectionTitle = selection?.getAttribute("data-product-title") || selection?.getAttribute("data-title");

            const selectionProductPrice = selectionTrade ? applyTradeDiscount(Number(variantData?.price)) : Number(variantData?.price);
            const selectionProductPriceCompare = selectionTrade ? Number(variantData?.price) : Number(variantData?.priceCompare);

            const selectionProductPriceUnit = selectionProductPrice || 0;
            const selectionProductPriceUnitCompare = selectionProductPriceCompare || 0;
            const selectionProductPriceTotal = selectionProductPriceUnit * selectionMultiplier;
            const selectionProductPriceCompareTotal = selectionProductPriceUnitCompare * selectionMultiplier;

            const selectionProductPriceCompareFormatted = selectionProductPriceCompare === 0 ? window.lightbuilder.copy.general.included : formatMoney(selectionProductPriceCompare);
            const selectionProductPriceCompareTotalFormatted = selectionProductPriceCompareTotal === 0 ? window.lightbuilder.copy.general.included : formatMoney(selectionProductPriceCompareTotal);
            const selectionProductPriceUnitFormatted = selectionProductPriceUnit === 0 ? window.lightbuilder.copy.general.included : formatMoney(selectionProductPriceUnit);
            const selectionProductPriceUnitCompareFormatted = selectionProductPriceUnitCompare === 0 ? window.lightbuilder.copy.general.included : formatMoney(selectionProductPriceUnitCompare);
            const selectionProductPriceTotalFormatted = selectionProductPriceUnit === 0 ? window.lightbuilder.copy.general.included : formatMoney(selectionProductPriceUnit);

            tablePriceTotal += selectionProductPriceTotal;

            // Print HTML 
            let rowHTML = window.lightbuilder.templates.orderSummaryRow;

            rowHTML = typeof stepTitle != "undefined" ? rowHTML.replaceAll("$STEP_TITLE", stepTitle) : rowHTML;
            rowHTML = typeof stepNumber != "undefined" ? rowHTML.replaceAll("$STEP_NUMBER", stepNumber) : rowHTML;
            rowHTML = typeof stepSummaryName != "undefined" ? rowHTML.replaceAll("$STEP_SUMMARY_NAME", stepSummaryName) : rowHTML;
            rowHTML = typeof selectionTitle != "undefined" ? rowHTML.replaceAll("$OPTION_TITLE", selectionTitle) : rowHTML;
            rowHTML = typeof selectionMultiplier != "undefined" ? rowHTML.replaceAll("$OPTION_QUANTITY", selectionMultiplier) : rowHTML;
            rowHTML = typeof selectionProductPriceUnitCompareFormatted != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_UNIT_COMPARE_FORMATTED", selectionProductPriceUnitCompareFormatted) : rowHTML;
            rowHTML = typeof selectionProductPriceUnitCompare != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_UNIT_COMPARE", selectionProductPriceUnitCompare) : rowHTML;
            rowHTML = typeof selectionProductPriceUnitFormatted != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_UNIT_FORMATTED", selectionProductPriceUnitFormatted) : rowHTML;
            rowHTML = typeof selectionProductPriceUnit != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_UNIT", selectionProductPriceUnit) : rowHTML;
            rowHTML = typeof selectionProductPriceCompareFormatted != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_COMPARE_FORMATTED", selectionProductPriceCompareFormatted) : rowHTML;
            rowHTML = typeof selectionProductPriceCompareTotalFormatted != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_COMPARE_TOTAL_FORMATTED", selectionProductPriceCompareTotalFormatted) : rowHTML;
            rowHTML = typeof selectionProductPriceTotalFormatted != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_TOTAL_FORMATTED", selectionProductPriceTotalFormatted) : rowHTML;
            rowHTML = typeof selectionProductPriceTotal != "undefined" ? rowHTML.replaceAll("$OPTION_PRICE_TOTAL", selectionProductPriceTotal) : rowHTML;
            rowHTML = typeof selectionVariantId != "undefined" ? rowHTML.replaceAll("$OPTION_VARIANT_ID", selectionVariantId) : rowHTML;

            if (typeof selectionProductPriceUnit == "number") {
              rowHTML = rowHTML.replaceAll("$OPTION_CLASS_PRICE_COMPARE", 'text--subdued price price--compare');
              rowHTML = rowHTML.replaceAll("$OPTION_CLASS_PRICE", 'price price--highlight');
            }

            // Node
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = rowHTML;

            const node = tempDiv.firstChild;

            const labelPriceCompare = node.querySelector(`[data-label="OptionPriceCompare"]`);
            const labelPrice = node.querySelector(`[data-label="OptionPrice"]`);
            const labelQuantity = node.querySelector(`[data-quantity]`);
            const nodeOptions = node.querySelector(`[data-selected-options]`);

            if (selectionMultiplier <= 1) {
              labelQuantity.setAttribute("hidden", true);
            }

            if (!selectionProductPriceUnitCompare) {
              labelPriceCompare.setAttribute("hidden", true);;
            }

            if (!selectionProductPriceUnit) {
              labelPrice.innerHTML = window.lightbuilder.copy.general.included;
              labelPrice.classList.add("text--subdued");
              labelPrice.classList.remove("price--highlight");
            }

            if (variantData?.options && variantData?.options?.length > 0) {
              for (let i = 0; i < variantData.options.length; i++) {

                const optionName = productData.options[i];
                const selectedOptionTitle = variantData.options[i];

                let optionHTML = window.lightbuilder.templates.orderTableSelectedOption;

                optionHTML = optionHTML.replaceAll("$SELECTED_OPTION_TITLE", selectedOptionTitle);
                optionHTML = optionHTML.replaceAll("$OPTION_NAME", optionName);

                nodeOptions.insertAdjacentHTML("beforeend", optionHTML);

              }
            }

            this.table.appendChild(node);

          }
          else {

            // Print HTML 
            let rowHTML = window.lightbuilder.templates.orderSummaryRow;

            rowHTML = rowHTML.replaceAll("$STEP_TITLE", stepTitle);
            rowHTML = rowHTML.replaceAll("$STEP_NUMBER", stepNumber);
            rowHTML = rowHTML.replaceAll("$STEP_SUMMARY_NAME", stepSummaryName);

            rowHTML = rowHTML.replaceAll("$OPTION_TITLE", `<span class="builder-tag builder-tag--danger">${window.lightbuilder.copy.order_summary.not_selected }</span>`);
            rowHTML = rowHTML.replaceAll("$OPTION_QUANTITY", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_UNIT_COMPARE_FORMATTED", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_UNIT_COMPARE", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_UNIT_FORMATTED", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_UNIT", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_COMPARE_FORMATTED", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_COMPARE_TOTAL_FORMATTED", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_TOTAL_FORMATTED", "");
            rowHTML = rowHTML.replaceAll("$OPTION_PRICE_TOTAL", "");
            rowHTML = rowHTML.replaceAll("$OPTION_VARIANT_ID", "");

            let optionMessageHTML = window.lightbuilder.copy.order_summary.please_select;
            optionMessageHTML = optionMessageHTML.replaceAll(`{{ item }}`, stepSummaryName);

            let optionHTML = window.lightbuilder.templates.orderTableSelectedOption;
            optionHTML = optionHTML.replaceAll("$SELECTED_OPTION_TITLE", optionMessageHTML);
            optionHTML = optionHTML.replaceAll("$OPTION_NAME", "");

            // Node
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = rowHTML;

            const node = tempDiv.firstChild;
            const nodeNameRow = node.querySelector(`[data-row-name]`);
            const nodeActionsRow = node.querySelector(`[data-row-actions]`);
            const nodePricesRow = node.querySelector(`[data-row-prices]`);
            const nodeOptions = node.querySelector(`[data-selected-options]`);

            nodePricesRow.innerHTML = "";
            nodeOptions.innerHTML = optionHTML;

            node.classList.add("builder-summary-table__row--invalid");

            this.table.appendChild(node);

          }
          

        }

      }

      let tablePriceTotalFormatted = formatMoney(tablePriceTotal);

      this.querySelector(`[data-price-total]`).innerText = tablePriceTotalFormatted;

      // Calculates the total to show at the bottom of the table.
      this.updateTotal();
      this.updateLeadTime();
      this.updateAddToCart();


    }

    update() {

      

    }

    calculateTotal() {

      let total = 0;

      const rows = this.querySelectorAll(`.builder-summary-table__row`);
      const addons = this.querySelectorAll(`.builder-order-summary__addon-checkbox:checked`);

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const unitPrice = Number(row.dataset.optionPriceUnit);
        const quantity = row.dataset.optionQuantity ? Number(row.dataset.optionQuantity) : 1;
        const totalPrice = unitPrice * quantity;
        if (unitPrice > 0) {
          total += totalPrice;
        }
      }

      for (let i = 0; i < addons.length; i++) {
        
        const addon = addons[i];
        const trade = addon.hasAttribute('data-trade-discount');
        const addonVariantPrice = Number(addon.dataset.addonVariantPrice);
        
        const price = trade ? applyTradeDiscount(addonVariantPrice) : addonVariantPrice;
        
        if (price > 0) {
          total += price;
        }

      }

      return total;
      
    }

    updateTotal(total) {

      if (!total) {
        total = this.calculateTotal();
      }

      if (!total) {
        return;
      }

      const totalFormatted = formatMoney(total);

      this.querySelector(`[data-price-total]`).innerText = totalFormatted;
      
      
    }

    updateAddToCart() {

      let disabled = this.querySelectorAll(`.builder-summary-table__row--invalid`).length > 0 ? true : false;

      this.addToCartButton.disabled = disabled;

    }

    updateLeadTime() {

      const leadTimeNotice = this.leadTimeNotice;
      const selections = this.builder.getSelections();

      const elementsHeading = leadTimeNotice.querySelectorAll(`[data-lower-bound]`);
      const elementsLowerBound = leadTimeNotice.querySelectorAll(`[data-lower-bound]`);
      const elementsUpperBound = leadTimeNotice.querySelectorAll(`[data-upper-bound]`);

      let lowerBound = lightbuilder.builder.general.leadTime.lowerBound;
      let upperBound = lightbuilder.builder.general.leadTime.upperBound;

      let contentHeading = lightbuilder.builder.general.leadTime.heading;
      let contentMessage = lightbuilder.builder.general.leadTime.message;

      // Calculate

      for (let i = 0; i < selections.length; i++) {
        const selection = selections[i];
        const selectionLowerBound = Number(selection.dataset.leadTimeLowerBound);
        const selectionUpperBound = Number(selection.dataset.leadTimeUpperBound);

        if (typeof selectionLowerBound == "number" && selectionLowerBound >= lowerBound) {
          lowerBound = selectionLowerBound;
        }

        if (typeof selectionUpperBound == "number" && selectionUpperBound >= upperBound) {
          upperBound = selectionUpperBound;
        }
      }
      
      contentHeading = contentHeading.replace(`{{ lower_bound }}`, lowerBound);
      contentHeading = contentHeading.replace(`{{ upper_bound }}`, upperBound);

      contentMessage = contentMessage.replace(`{{ lower_bound }}`, lowerBound);
      contentMessage = contentMessage.replace(`{{ upper_bound }}`, upperBound);

      // Replace

      elementsLowerBound.forEach((el) => {
        el.innerText = lowerBound;
      });

      elementsUpperBound.forEach((el) => {
        el.innerText = upperBound;
      });

      console.log(lowerBound);
      console.log(upperBound);

      leadTimeNotice.setAttribute('data-lead-time-min', lowerBound);
      leadTimeNotice.setAttribute('data-lead-time-max', upperBound);

    }

    get leadTimeNotice() {
      return this.querySelector(`builder-lead-time-notice`);
    }

    async out(shouldAnimate = true) {

      // Animation
      const animation = bAnimate(this, 'leave');
      shouldAnimate ? animation.play() : animation.finish();

      await animation.finished;

      this.classList.remove("builder-order-summary--active");

      return animation.finished;

    }

    async in(shouldAnimate = true) {

      this.classList.add("builder-order-summary--active");

      // Animation
      const animation = bAnimate(this, 'enter');
      shouldAnimate ? animation.play() : animation.finish();

      return animation.finished;

    }


    /* ---------- Event Handlers ---------- */

    async _onFormSubmit(e) {

      console.log(`_onFormSubmit`);

      e.preventDefault();

      const hidden = "_";

      /* ----- Collect all items to add to cart ----- */

      const bundleId = uuid();
      const items = [];
      const parentProperties = {};
  
      let quantity = this.querySelector(`.quantity-selector__input`).value || 1;

      const leadTimeMin = this.leadTime?.getAttribute(`data-lead-time-min`);
      const leadTimeMax = this.leadTime?.getAttribute(`data-lead-time-max`);
      const leadTimeInterval = this.leadTime?.getAttribute(`data-lead-time-interval`);

      // Lead Time
      
      let leadTimeMessage = "";

      if (leadTimeMin && leadTimeInterval) {
        leadTimeMessage += `${ leadTimeMin }`;
        if (leadTimeMax) {
          leadTimeMessage += ` - ${ leadTimeMax }`;
        }
        leadTimeMessage += ` ${ leadTimeInterval }`;
        parentProperties[`${hidden}Builder Lead Time`] = leadTimeMessage;
      }

      // Base Properties
      parentProperties[`${hidden}Builder ID`] = bundleId;
      parentProperties[`${hidden}Builder Item Name`] = this.builder.dataset.builderItemName;
      parentProperties[`${hidden}Builder Product Type`] = "Parent";

      /* ----- Components ----- */

      // Get all steps
      const steps = this.builder.steps.steps;

      // Loop through each step
      for (const step of steps) {

        const stepSummaryName = step.dataset.summaryName || step.dataset.title;
        const stepType = step.dataset.stepType;

        const componentProperties = {};
        componentProperties[`${hidden}Builder ID`] = bundleId;
        componentProperties[`${hidden}Builder Item Name`] = this.builder.dataset.builderItemName;
        componentProperties[`${hidden}Builder Product Type`] = "Component";
        
        if (leadTimeMessage) {
          componentProperties[`${hidden}Builder Lead time`] = leadTimeMessage;
        }

        let selectedElement = step.querySelector(builderSelectors.finalSelection);;

        // Skip info and summary steps
        if (stepType === 'info' || stepType === 'summary') {
          continue;
        }

        if (!selectedElement) {
          continue;
        }

        
        let lineItemObject;

        // Step Type Specific Actions ----

        switch (stepType) {
          case 'collection':
            break;
          case 'product':
            break;
          case 'product_in_collection':
            selectedElement = step.querySelector(`[data-step-type="product_in_collection"] builder-product-step.builder-product-step--active`);
            break;
          case 'option':
            const optionTitle = step.selection?.dataset?.title;

            // Store as line item property
            // Use the step's summary name as the property key
            if (stepSummaryName && optionTitle) {
              parentProperties[stepSummaryName] = optionTitle;
            }
            break;
        }

        // General Actions -----

        let variantId;

        if (step.type == "multistep-parent") {
          variantId = step.selectedVariantId;
        }
        else {
          variantId = selectedElement?.dataset.variantId;
        }

        if (variantId) {
          // Get multiplier if this step has one
          const multiplier = step.dataset.multiplier;
          if (multiplier && !isNaN(parseInt(multiplier))) {
            quantity = quantity * parseInt(multiplier);
          }

          lineItemObject = {
            id: variantId,
            quantity: quantity,
            properties: componentProperties
          };

        }

        if (lineItemObject?.id) {
          items.push(lineItemObject);
        }
        
      }

      /* ----- Addons ----- */

      console.log(`Addons`);

      // Loop through selected addons
      const addonCheckboxes = this.querySelectorAll('.builder-order-summary__addon input[type="checkbox"]:checked');

      for (const checkbox of addonCheckboxes) {
        const addonVariantId = Number(checkbox.dataset?.addonVariantId);

        if (!addonVariantId) {
          continue;
        }

        const addonProperties = {};
        addonProperties[`${hidden}Builder ID`] = bundleId;
        addonProperties[`${hidden}Builder Item Name`] = this.builder.dataset.builderItemName;
        addonProperties[`${hidden}Builder Product Type`] = "Addon";

        if (addonVariantId) {
          items.push({
            id: addonVariantId,
            quantity: 1,
            properties: addonProperties
          });
        }
      }

      // Add the builder product itself (the main light fixture)

      if (lightbuilder.builder.general.product.enable) {
        const builderProduct = this.builder.builderProduct;
        if (builderProduct && builderProduct.variants[0]) {
          items.unshift({
            id: builderProduct.variants[0].id,
            quantity: 1,
            properties: parentProperties
          });
        }  
      }

      // console.log('Items to add to cart:', items);
      // console.log('Properties:', parentProperties);

      // Make the cart/add.js API call
      if (items.length > 0) {
        try {

          console.log('Add to Cart - Try');

          if (this.addToCartButton.getAttribute("is") == "loader-button") {
            this.addToCartButton.setAttribute("disabled", "disabled");
            this.addToCartButton.setAttribute("aria-busy", "true");
          }
          
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            throw new Error('Failed to add items to cart');
          }

          const result = await response.json();
          // console.log('Cart add result:', result);

          // Fetch updated cart and dispatch events
          const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
          const cartContent = await cartResponse.json();

          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: window.themeVariables.settings.cartType === 'drawer'
            }
          }));

        } catch (error) {
          console.log('Add to Cart - Catch');

          console.error('Error adding to cart:', error);
        }
        finally {
          console.log('Add to Cart - Finally');
          if (this.addToCartButton.getAttribute("is") == "loader-button") {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
          }
        }
      }

    }

    /* ---------- Trade Discount ---------- */

    get tradeDiscounted() {
      return this.hasAttribute('data-trade-discount');
    }

    /* ---------- Elements ---------- */

    get builder() {
      return this.closest("builder-main");
    }
    get table() {
      return this.querySelector(`.builder-summary-table`);
    }
    get form() {
      return this.querySelector(`[data-add-to-cart-form]`);
    }
    get addToCartButton() {
      return this.querySelector(`[data-add-to-cart]`);
    }
    get leadTime() {
      return this.querySelector(`builder-lead-time-notice`);
    };

  }


  var BuilderViewer = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
      this._addEventListeners();
    }

    connectedCallback() {
      this._init();
    }

    _init() {

      if (this.ready) {
        // console.log(`${Variant3D.debug.appstub} Library Loaded.`, Variant3D.debug.styles.app, Variant3D.debug.styles.success);
      }
      else {
        // console.log(`${Variant3D.debug.appstub} Library not loaded.`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
      }

      try {

        var settings = { apiKey: Variant3D.API.key };
        Variant.init(settings);
        this.updateViewer();

      } catch (error) {

        // console.log(`${Variant3D.debug.appstub} Error Loading Library. ${error}`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
        return;

      }

    }

    reset() {
      this.updateViewer();
    }

    _addEventListeners() {
      
      this.builder.addEventListener(`viewer:update`, this._onUpdate.bind(this));
      this.builder.addEventListener(`viewer:update:start`, this._onUpdateStart.bind(this));
      this.builder.addEventListener(`viewer:update:end`, this._onUpdateEnd.bind(this));
      
      this.viewer.addEventListener(`error`, this._onViewerError.bind(this));
      this.viewer.addEventListener(`before-render`, this._onViewerBeforeRender.bind(this));
      this.viewer.addEventListener(`load`, this._onViewerLoad.bind(this));
      this.viewer.addEventListener(`poster-dismissed`, this._onViewerPosterDismissed.bind(this));
      this.viewer.addEventListener(`model-visibility`, this._onViewerModelVisibility.bind(this));
      this.viewer.addEventListener(`progress`, this._onViewerProgress.bind(this));
      this.viewer.addEventListener(`render-scale`, this._onViewerRenderScale.bind(this));

    }
    

    /* ---------- Functions ---------- */

    toggleTheme() {

      if (this.theme === 'dark') {
        this.classList.remove('builder-viewer--dark');
      }
      else {
        this.classList.add('builder-viewer--dark');
      }

    }

    get theme() {
      if (this.classList.contains('builder-viewer--dark')) {
        return 'dark';
      }
      return 'light';
    }

    getMaterialsFromElement(element) {

      if (!element) {
        return;
      }

      const materials = [];
      const dataMaterials = element.dataset.variant3dMaterials;
      const dataMeshes = element.dataset.variant3dMeshes;

      if (!dataMaterials) {
        return;
      }

      let materialTags;
      let meshTags;

      try {
        materialTags = JSON.parse(dataMaterials);
      } catch {
        materialTags = dataMaterials;
      }

      try {
        meshTags = JSON.parse(dataMeshes);
      } catch {
        meshTags = dataMeshes;
      }

      if (Array.isArray(materialTags)) {

        if (materialTags.length === 0 || meshTags.length === 0) {
          return;
        }

        for (let i = 0; i < meshTags.length; i++) {
          const meshTag = meshTags[i];
          for (let e = 0; e < materialTags.length; e++) {
            const materialTag = materialTags[e];
            materials.push({
              meshTag: meshTag,
              tag: materialTag
            });
          }
        }
        
      }

      return materials;

    }

    getMaterialGroupFromElement(element, group) {

      if (!element || !group) {
        return;
      }

      const materialGroup = [];

      // const dataMeshesStub = `variant3dGroup${group}Meshes`;
      // const dataMaterialsStub = `variant3dGroup${group}Materials`;
      
      const dataMeshesStub = `data-variant3d-group${group}-meshes`;
      const dataMaterialsStub = `data-variant3d-group${group}-materials`;

      const dataMaterials = element.getAttribute(dataMaterialsStub);
      const dataMeshes = element.getAttribute(dataMeshesStub);

      if (!dataMaterials || !dataMeshes) {
        return;
      }

      let materialTags;
      let meshTags;

      try {
        materialTags = JSON.parse(dataMaterials);
      } catch {
        materialTags = dataMaterials;
      }

      try {
        meshTags = JSON.parse(dataMeshes);
      } catch {
        meshTags = dataMeshes;
      }

      if (Array.isArray(materialTags)) {

        if (materialTags.length === 0 || meshTags.length === 0) {
          return;
        }

        for (let i = 0; i < meshTags.length; i++) {
          const meshTag = meshTags[i];
          for (let e = 0; e < materialTags.length; e++) {
            const materialTag = materialTags[e];
            materialGroup.push({
              meshTag: meshTag,
              tag: materialTag
            });
          }
        }

      }

      return materialGroup;

    }

    getMeshesFromElement(element) {

      // console.log(`${Variant3D.debug.appstub} getMeshesFromElement`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
      // console.log(element);

      if (!element) {
        // console.log(`${Variant3D.debug.appstub} getMeshesFromElement - no element.`, Variant3D.debug.styles.app, Variant3D.debug.styles.danger);
        return;
      }

      const meshes = [];
      const dataMeshes = element.dataset.variant3dMeshes;

      let meshTags;

      // console.log(`${Variant3D.debug.appstub} getMeshesFromElement - dataMeshes.`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);
      // console.log(dataMeshes);

      // validate/sanitize input
      try {
        meshTags = JSON.parse(dataMeshes);
      } catch {
        meshTags = dataMeshes;
      }

      if (!meshTags) {
        return null;
      }

      // console.log(`${Variant3D.debug.appstub} getMeshesFromElement - meshTags.`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);
      // console.log(meshTags);

      if (Array.isArray(meshTags)) {

        // Enable multiple meshes stored in array.

        if (meshTags.length === 0) {
          return null;
        }

        for (let i = 0; i < meshTags.length; i++) {
          const meshtag = meshTags[i];

          if (!meshtag) {
            continue;
          }

          meshes.push({
            tag: meshtag,
            enabled: true
          });
        }
      }
      else {

        // Enable single mesh stored as string.

        meshes.push({
          tag: meshTags,
          enabled: true
        });
      }

      // console.log(`${Variant3D.debug.appstub} getMeshesFromElement - meshes.`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);
      // console.log(meshes);

      return meshes;

    }

    getMeshesFromSelections(selects) {
      const selections = selects || this.builder.getSelections();
      const variant3DSelections = Variant3DHelper.filterVariant3DOptions(selections);
      const meshes = {};

      if (!variant3DSelections || variant3DSelections.length === 0) {
        return;
      }

      for (let i = 0; i < variant3DSelections.length; i++) {
        const selection = variant3DSelections[i];
        const selectionMeshes = this.getMeshesFromElement(selection);

        if (selectionMeshes?.length > 0) {
          for (let j = 0; j < selectionMeshes.length; j++) {
            const mesh = selectionMeshes[j];
            // Use the mesh tag as the key to ensure uniqueness
            // Later selections will overwrite earlier ones with the same tag
            meshes[mesh.tag] = mesh;
          }
        }
      }

      // Convert the object back to an array
      return Object.values(meshes);
    }

    getMeshExclusionsFromElement(element) {
      if (!element) {
        return;
      }

      const meshExclusions = [];
      const dataMeshExclusions = element.dataset.variant3dMeshExclusions;

      if (!dataMeshExclusions) {
        return [];
      }

      let meshExclusionTags;

      try {
        meshExclusionTags = JSON.parse(dataMeshExclusions);
      } catch {
        meshExclusionTags = dataMeshExclusions;
      }

      if (Array.isArray(meshExclusionTags)) {
        return meshExclusionTags;
      } else if (typeof meshExclusionTags === 'string') {
        return [meshExclusionTags];
      }

      return [];
    }

    getMeshExclusionsFromSelections(selects) {
      const selections = selects || this.builder.getSelections();
      const meshExclusions = new Set();

      for (let i = 0; i < selections.length; i++) {
        const selection = selections[i];
        const selectionMeshExclusions = this.getMeshExclusionsFromElement(selection);

        if (selectionMeshExclusions?.length > 0) {
          for (let j = 0; j < selectionMeshExclusions.length; j++) {
            meshExclusions.add(selectionMeshExclusions[j]);
          }
        }
      }

      return Array.from(meshExclusions);
    }

    getMaterialsFromSelections(selects) {

      const selections = selects || this.builder.getSelections();
      const variant3DSelections = Variant3DHelper.filterVariant3DOptions(selections);

      const materials = {};

      if (!variant3DSelections || variant3DSelections.length === 0) {
        return;
      }

      for (let i = 0; i < variant3DSelections.length; i++) {
        const selection = variant3DSelections[i];
        const selectionMaterials = this.getMaterialsFromElement(selection);

        if (selectionMaterials?.length > 0) {
          for (let j = 0; j < selectionMaterials.length; j++) {
            const material = selectionMaterials[j];
            // Use the material tag as the key to ensure uniqueness
            // Later selections will overwrite earlier ones with the same tag
            materials[material.tag] = material;
          }
        }

      }

      // Convert the object back to an array
      return Object.values(materials);

    }

    getMaterialGroupFromSelections(selects, group) {

      if (!group) {
        return;
      }

      const selections = selects || this.builder.getSelections();
      const variant3DSelections = Variant3DHelper.filterVariant3DOptions(selections);

      if (!selections) {
        return;
      }

      const materials = {};

      if (!variant3DSelections || variant3DSelections.length === 0) {
        return;
      }

      for (let i = 0; i < variant3DSelections.length; i++) {
        const selection = variant3DSelections[i];
        const selectionMaterials = this.getMaterialGroupFromElement(selection, group);

        if (selectionMaterials?.length > 0) {
          for (let j = 0; j < selectionMaterials.length; j++) {
            const material = selectionMaterials[j];
            // Use the material tag as the key to ensure uniqueness
            // Later selections will overwrite earlier ones with the same tag
            materials[material.tag] = material;
          }
        }

      }

      // Convert the object back to an array
      return Object.values(materials);

    }

    getProductCodeFromSelections(selects) {

      // Given a NodeList of selections, return the product code from the first selection that has one.

      const selections = selects || this.builder.getSelections();
      const variant3DSelections = Variant3DHelper.filterVariant3DOptions(selections);

      let productCode = null;

      if (!variant3DSelections || variant3DSelections.length === 0) {
        return;
      }

      for (let i = 0; i < variant3DSelections.length; i++) {
        const selection = variant3DSelections[i];
        if (selection.dataset.variant3dProductCode) {
          productCode = selection.dataset.variant3dProductCode;
        }
      }

      return productCode;

    }

    validateMeshes(meshes) {

      if (!meshes) {
        return false;
      }

      if (meshes.length === 0) {
        return false;
      }

      return true;

    }

    validateMaterials(materials) {

      if (!materials) {
        return false;
      }

      if (materials.length === 0) {
        return false;
      }

      return true;

    }

    getRandomDefault() {

      const randomSelections = this.builder.getRandomSelections();
      const payload = this.getViewerPayload(randomSelections);

      return payload;

    }

    getViewerPayload(selects) {

      const productCode = this.getProductCodeFromSelections(selects);

      // Build options object
      const options = {};

      let meshes = this.getMeshesFromSelections(selects);
      let materials = this.getMaterialsFromSelections(selects);
      
      let materialGroups = [];

      let materialGroup1 = this.getMaterialGroupFromSelections(selects, 1);
      let materialGroup2 = this.getMaterialGroupFromSelections(selects, 2);
      let materialGroup3 = this.getMaterialGroupFromSelections(selects, 3);

      materialGroups.push(materialGroup1);
      materialGroups.push(materialGroup2);
      materialGroups.push(materialGroup3);
      
      const meshExclusions = this.getMeshExclusionsFromSelections(selects);
      
      // Filter out excluded meshes
      if (meshExclusions && meshExclusions.length > 0 && meshes) {
        meshes = meshes.filter(mesh => !meshExclusions.includes(mesh.tag));
      }

      // Meshes

      let allMeshes;
      let allMaterials;

      if (this.validateMeshes(meshes)) {
        allMeshes = meshes;
        // options.meshes = meshes;
      }

      // Materials

      if (this.validateMaterials(materials)) {
        allMaterials = materials;
        // options.materials = materials;
      }

      // Material Groups

      for (let i = 0; i <= 2; i++) {

        let materialGroup = materialGroups[i];

        if (!materialGroup || materialGroup?.length == 0) {
          continue;
        }

        if (this.validateMaterials(materialGroup)) {
          
          const materialGroupElement = materialGroup[0];
          const materialGroupMesh = materialGroupElement.meshTag;
          const materialGroupMaterial = materialGroupElement.tag;

          // Add to Meshes
          this.ensureMesh(allMeshes, materialGroupMesh);

          // Add to Materials
          this.addReplaceMaterial(allMaterials, materialGroupMesh, materialGroupMaterial);

        }

      }

      if (allMeshes) {
        options.meshes = allMeshes;
      }

      if (allMaterials) {
        options.materials = allMaterials;
      }


      // Check if options has any properties
      const hasOptions = Object.keys(options).length > 0;

      if (!hasOptions || !productCode) {
        // console.log(`${Variant3D.debug.appstub} getViewerPayload - no options found, selecting default.`, Variant3D.debug.styles.app, Variant3D.debug.styles.warning);
        const randomDefault = this.getRandomDefault();
        return randomDefault; 
      }

      const payload = {
        productCode: productCode,
        options: options
      };

      // console.log(`${Variant3D.debug.appstub} getViewerPayload - VIEWER PAYLOAD:`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
      // console.log(payload);

      return payload;
    }

    ensureMesh = function(meshPayload, meshTag) {
      if (!meshPayload) return;
      if (!meshTag) return;
      const exists = meshPayload.some(mesh => mesh.tag === meshTag);
      if (!exists) meshPayload.push({ tag: meshTag, enabled: true });
    }

    addReplaceMaterial = function(materialPayload, meshTag, tag) {
      if (!materialPayload) return;
      if (!meshTag) return;
      if (!tag) return;

      const index = materialPayload.findIndex(m => m.meshTag === meshTag);

      if (index !== -1) {
        materialPayload[index].tag = tag;
      } else {
        materialPayload.push({ meshTag, tag });
      }
    }

    async updateViewer(payload) {

      // console.log(`${Variant3D.debug.appstub} updateViewer()`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);

      const viewer = this;

      let data;

      if (payload) {
        if (viewer.validateViewerOptions(payload)) {
          data = payload;
        }
        else {
          return;
        }
      }
      else {
        data = viewer.getViewerPayload();
      }


      // If the options are invalid, don't update the viewer.
      if (!this.validateViewerOptions(data)) {
        // console.log(`${Variant3D.debug.appstub} _onUpdate - Invalid Options`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
        return;
      }
      else {
        // console.log(`${Variant3D.debug.appstub} _onUpdate - Updating`, Variant3D.debug.styles.app, Variant3D.debug.styles.success);
      }

      this.dispatchEvent(new CustomEvent('viewer:update:start', {
        bubbles: true,
        detail: {
          viewer: viewer
        }
      }));

      // const cleanData = Variant3DHelper.sanitizeVariant3DPayload(data);
      const cleanData = data;

      await Variant.loadToModelViewer(cleanData, viewer.viewer).then(
        
        function (e2) {
          // console.log(`${Variant3D.debug.appstub} _onUpdate - Variant3D Load Complete`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);

          viewer.dispatchEvent(new CustomEvent('viewer:update:end', {
            bubbles: true,
            detail: {
              viewer: viewer
            }
          }));

        }
      );

    }

    validateViewerOptions(data) {
      if (!data) {
        return false;
      }
      if (typeof data != "object") {
        return false;
      }
      if (!data.productCode) {
        return false;
      }
      if (!data.options) {
        return false;
      }
      return true;
    }
    
    /* ---------- Event Handlers ---------- */

    _onUpdate(e) {

      const element = e?.detail?.element;

      if (!element) {
        // console.log(`${Variant3D.debug.appstub} _onUpdate - No element`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
        return;
      }

      if (Variant && Variant3DHelper.hasVariant3DProperties(element)) {
        let payload = this.getViewerPayload();
        this.updateViewer(payload);
      }

    }

    _onUpdateStart(e) {

      this.loadingOverlay?.randomize();
      this.loading = true;

    }

    _onUpdateEnd(e) {

      this.loading = false;

    }

    _onSelection(e) {

      let payload = this.getViewerPayload();

      // If the options are valid, update the viewer.
      if (this.validateViewerOptions(payload)) {
        this.updateViewer(payload);
      }
      else {
        // console.log(`${Variant3D.debug.appstub} updateViewer - Invalid Options`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
      }

    }

    _onViewerError() {
      // console.log(`${Variant3D.debug.appstub} _onViewerError`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
    }
    _onViewerBeforeRender() {
      // console.log(`${Variant3D.debug.appstub} _onViewerBeforeRender`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
    }
    _onViewerLoad() {
      // console.log(`${Variant3D.debug.appstub} _onViewerLoad`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
      // console.log(this);
      this.loading = false;
    }
    _onViewerPosterDismissed() {
      // console.log(`${Variant3D.debug.appstub} _onViewerPosterDismissed`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
      this.loading = false;
    }
    _onViewerModelVisibility() {
      // console.log(`${Variant3D.debug.appstub} _onViewerModelVisibility`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
    }
    _onViewerProgress() {
      // console.log(`${Variant3D.debug.appstub} _onViewerProgress`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
    }
    _onViewerRenderScale() {
      // console.log(`${Variant3D.debug.appstub} _onViewerRenderScale`, Variant3D.debug.styles.app, Variant3D.debug.styles.info);
    }
    

    /* ---------- Attributes ---------- */

    get ready() {

      if (!Variant === false) {
        // console.log(`${Variant3D.debug.appstub} Library Loaded.`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);
      }
      else {
        // console.log(`${Variant3D.debug.appstub} Library not loaded.`, Variant3D.debug.styles.app, Variant3D.debug.styles.error);
        return false;
      }

      return true;
    }



    get loading() {
      return this.classList.contains("builder-viewer--loading")
    }
    set loading(boolean) {
      if (typeof boolean !== "boolean") {
        return;
      }
      if (boolean) {
        this.classList.add("builder-viewer--loading");
      } else {
        this.classList.remove("builder-viewer--loading");
      }
    }


    get productCode() {
      return this.dataset.productCode;
    }
    set productCode(value) {
      this.dataset.productCode = value;
    }

    /* ---------- Elements ---------- */

    get loadingOverlay() {
      return this.querySelector("builder-viewer-overlay");
    }

    get builder() {
      return this.closest("builder-main") || document.getElementById(this.dataset.builder);
    }

    get viewer() {
      return this.querySelector("model-viewer");
    }

    get caption() {
      return this.querySelector(`builder-viewer-caption`);
    }

  }


  var BuilderViewerCaption = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
      this._init();
    }
    
    _init() {
      
      // this.builder.addEventListener(`viewer-caption:update`, this.update.bind(this));
      this.builder.addEventListener(`viewer:update`, this.update.bind(this));
      
    }

    update(e) {

      // console.log(`${Variant3D.debug.appstub} update.`, Variant3D.debug.styles.app, Variant3D.debug.styles.default);

      let text;
      let price;
      
      const selections = this.builder.getSelections();

      price = 0;
      for (const selection of selections) {
        price += Number(selection.dataset.variantPrice);
      }

      this.updateText(text);
      
      if (this.labelText) {
        this.updateText(text);
      }
      
      if (this.labelPrice) {
        this.updatePrice(price);
      }

    }

    refresh() {

    }

    updateText(text) {

      if (text) {
        this.labelText.innerText = text;
      }
      else {
        this.labelText.innerText = lightbuilder.copy.viewer.caption.default;
      }
      
    }

    updatePrice(price) {

      if (!price) {
        this.labelPrice.setAttribute(`hidden`, true);
        return;
      }

      this.labelPrice.removeAttribute(`hidden`);

      const formattedPrice = formatMoney(price);
      this.labelPrice.innerText = formattedPrice;

    }

    get viewer() {
      const viewer = this.closest(`builder-viewer`);
      return viewer;
    }
    get builder() {
      const main = this.closest(`builder-main`);
      return main;
    }
    get ctaEnabled() {
      return this.hasAttribute(`.builder-viewer-caption--cta`);
    }

    get labelPrice() {
      return this.querySelector(`[data-caption-price]`);
    }
    get labelText() {
      return this.querySelector(`[data-caption-text]`);
    }


  }

  var BuilderViewerOverlay = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    _init() {
      this.updateText();
    }

    randomize() {

      const messages = lightbuilder.copy.viewer.loading.flavoured;

      if (messages.length > 0) {
        const message = messages[Math.floor(Math.random() * messages.length)];
        this.updateText(message);
      }

    }

    updateText(message) {
      let text = lightbuilder?.copy?.viewer?.loading?.default || "Loading Light..."
      if (message) {
        text = message;
      }
      this.textElement.innerHTML = text;
    }

    get textElement() {
      return this.querySelector(".builder-viewer__overlay-text");
    }

  }

  var BuilderViewerControls = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    _init() {

      this.buttonToggleTheme.addEventListener("click", this._onClickToggleTheme.bind(this));
      
    }
    
    _onClickToggleTheme() {
      this.builder?.viewer?.toggleTheme();
    }

    get builder() {
      return this.closest("builder-main") || document.getElementById(this.dataset.builder);
    }

    get buttonToggleTheme() {
      return this.querySelector(`[data-action="viewer-toggle-theme"]`);
    }

  }

  var BuilderCartGroup = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    _init() {
      
      this.addEventListener("builder-cart-group:loading:start", this._onLoadingStart.bind(this));
      this.addEventListener("builder-cart-group:loading:end", this._onLoadingEnd.bind(this));

    }

    _onLoadingStart() {
      this.loading = true;
    }

    _onLoadingEnd() {
      this.loading = false;
    }

    set loading(loading) {
      loading ? this.classList.add("builder-cart-group--loading") : this.classList.remove("builder-cart-group--loading");
    }

    get loading() {
      return this.classList.contains("builder-cart-group--loading");
    }

  }

  var BuilderCartGroupRemove = class extends HTMLElement {

    /* ---------- Setup ---------- */

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    get removeButtons() {
      return this.querySelectorAll(`[data-action="remove"]`);
    }

    _init() {

      this.removeButtons.forEach((el) => {
        el.addEventListener("click", this._onClickRemove.bind(this));
      });
    }

    _onClickRemove(e) {
      this.remove();
    }

    async remove() {

      const keys = this.dataset.keys;
      const keysArray = keys.split(",");

      const updates = {};

      for (let k = 0; k < keysArray.length; k++) {
        const key = keysArray[k];
        if (key === "" || !key) {
          continue;
        }
        updates[key] = 0;
      }

      // return;

      this.dispatchEvent(new CustomEvent("builder-cart-group:loading:start", {
        bubbles: true
      }));
 
      const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({ updates }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const cartContent = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));

    }

  }

  var BuilderCartGroupQuantity = class extends CustomHTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
    }

    _init() {

      this._units = this._parseUnits();

      if (!this._units || Object.keys(this._units).length === 0) {
        console.warn(`[builder-cart-group-quantity] No unit map found.`, this);
        return;
      }

      this._target = this.quantity;  // what the customer has asked for
      this._pending = false;         // a flush loop is running

      this.delegate.on("click", `[data-action="decrease"]`, this._onClickDecrease.bind(this));
      this.delegate.on("click", `[data-action="increase"]`, this._onClickIncrease.bind(this));
      this.delegate.on("change", `[data-bundle-input]`, this._onChangeInput.bind(this));
      this.delegate.on("keydown", `[data-bundle-input]`, this._onKeydownInput.bind(this));

      this._syncUI();

    }

    /* ---------- Functions ---------- */

    _parseUnits() {

      const node = this.querySelector(`[data-bundle-units]`);

      if (!node) {
        return null;
      }

      try {

        const parsed = JSON.parse(node.textContent);

        // Coerce to positive integers. A zero or NaN unit would freeze that
        // line at its current quantity while the rest of the bundle moved,
        // which is the exact corruption this element exists to prevent.
        return Object.fromEntries(
          Object.entries(parsed)
            .map(([key, unit]) => [key, parseInt(unit, 10)])
            .filter(([, unit]) => Number.isInteger(unit) && unit > 0)
        );

      } catch (error) {
        console.error(`[builder-cart-group-quantity] Invalid unit JSON.`, error);
        return null;
      }

    }

    // bundleQuantity -> { lineKey: absoluteLineQuantity }
    _buildUpdates(bundleQuantity) {
      return Object.fromEntries(
        Object.entries(this._units).map(([key, unit]) => [key, bundleQuantity * unit])
      );
    }

    // What the cart actually granted, expressed in whole bundles.
    _settledQuantity(cart) {

      const quantities = new Map(cart.items.map((item) => [item.key, item.quantity]));

      let achievable = Infinity;

      for (const [key, unit] of Object.entries(this._units)) {
        achievable = Math.min(achievable, Math.floor((quantities.get(key) ?? 0) / unit));
      }

      return Number.isFinite(achievable) ? Math.max(0, achievable) : 0;

    }

    async _post(updates) {

      const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({ updates }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const cartContent = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(cartContent?.description || cartContent?.message || `Cart update failed (${response.status})`);
      }

      return cartContent;

    }

    set(next) {

      const desired = Math.max(0, Math.trunc(next) || 0);

      if (desired === this._target) {
        return;
      }

      this._target = desired;
      this._syncUI();
      this._flush();

    }

    async _flush() {

      if (this._pending) {
        return;
      }

      this._pending = true;
      this.loading = true;

      let cartContent = null;

      try {

        while (this._target !== this.quantity) {

          const desired = this._target;

          cartContent = await this._post(this._buildUpdates(desired));

          // Inventory may have clamped one line but not the others, leaving a
          // structurally invalid bundle (5 frames, 12 pendants). Floor the whole
          // group to a valid multiple and re-issue.
          const settled = this._settledQuantity(cartContent);

          if (settled !== desired) {
            cartContent = await this._post(this._buildUpdates(settled));
          }

          this.quantity = settled;

          // Accept the clamp only if the customer hasn't changed their mind
          // while we were waiting — otherwise this loops forever.
          if (this._target === desired) {
            this._target = settled;
          }

          this._syncUI();

        }

      } catch (error) {

        console.error(`[builder-cart-group-quantity]`, error);

        this._target = this.quantity;
        this._syncUI();

        this.dispatchEvent(new CustomEvent("builder-cart-group:error", {
          bubbles: true,
          detail: {
            element: this,
            error: error
          }
        }));

      } finally {

        this._pending = false;
        this.loading = false;

        if (cartContent) {
          this._broadcast(cartContent);
        }

      }

    }

    _broadcast(cartContent) {

      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));

    }

    _syncUI() {

      // The drawer re-renders on cart:refresh, so this can fire on a detached node.
      if (!this.isConnected) {
        return;
      }

      const value = String(this._target);

      if (this.input) {
        this.input.value = value;
        this.input.size = Math.max(2, value.length);
      }

      this.buttonDecrease?.toggleAttribute("disabled", this._target <= 0);

    }

    /* ---------- Event Handlers ---------- */

    _onClickDecrease(event) {
      event.preventDefault();
      this.set(this._target - 1);
    }

    _onClickIncrease(event) {
      event.preventDefault();
      this.set(this._target + 1);
    }

    _onChangeInput(event, target) {
      const value = parseInt(target.value, 10);
      this.set(Number.isNaN(value) ? this.quantity : value);
    }

    _onKeydownInput(event, target) {
      if (event.key === "Enter") {
        event.preventDefault();
        target.blur();
      }
    }

    /* ---------- Properties ---------- */

    get bundleId() {
      return this.dataset.bundleId;
    }

    get quantity() {
      return parseInt(this.dataset.quantity, 10) || 0;
    }
    set quantity(value) {
      this.dataset.quantity = String(Math.max(0, Math.trunc(value) || 0));
    }

    get loading() {
      return this.hasAttribute("aria-busy");
    }
    set loading(loading) {

      if (loading) {
        this.setAttribute("aria-busy", "true");
      }
      else {
        this.removeAttribute("aria-busy");
      }

      // BuilderCartGroup listens for these and toggles its loading class.
      this.dispatchEvent(new CustomEvent(`builder-cart-group:loading:${ loading ? "start" : "end" }`, {
        bubbles: true
      }));

    }

    /* ---------- Elements ---------- */

    get group() {
      return this.closest(`builder-cart-group`);
    }

    get input() {
      return this.querySelector(`[data-bundle-input]`);
    }

    get buttonDecrease() {
      return this.querySelector(`[data-action="decrease"]`);
    }

    get buttonIncrease() {
      return this.querySelector(`[data-action="increase"]`);
    }

  }

  // js/custom-element/section/product/image-zoom.js
  var PhotoSwipeUi = class {
    constructor(pswp) {
      this.photoSwipeInstance = pswp;
      this.delegate = new main_default(this.photoSwipeInstance.scrollWrap);
      this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
      this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui");
      this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this));
      this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this));
      this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this));
      this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this));
      this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this));
      this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this));
      this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this));
      this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this));
      this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this));
      this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this));
      this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
    }
    init() {
      const prevNextButtons = this.pswpUi.querySelector(".pswp__prev-next-buttons"), dotsNavWrapper = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
      if (this.photoSwipeInstance.items.length <= 1) {
        prevNextButtons.style.display = "none";
        dotsNavWrapper.style.display = "none";
        return;
      }
      prevNextButtons.style.display = "";
      dotsNavWrapper.style.display = "";
      let dotsNavHtml = "";
      this.photoSwipeInstance.items.forEach((item, index) => {
        dotsNavHtml += `
        <button class="dots-nav__item tap-area" ${index === 0 ? 'aria-current="true"' : ""} data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${index}</span>
        </button>
      `;
      });
      dotsNavWrapper.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = dotsNavHtml;
    }
    _close() {
      this.photoSwipeInstance.close();
    }
    _goToPrev() {
      this.photoSwipeInstance.prev();
    }
    _goToNext() {
      this.photoSwipeInstance.next();
    }
    _moveTo(event, target) {
      this.photoSwipeInstance.goTo([...target.parentNode.children].indexOf(target));
    }
    _onPswpClosed() {
      this.delegate.off("pswpTap");
    }
    _onPswpDoubleTap(point) {
      const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
      if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
        this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
      } else {
        this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : this.maxSpreadZoom, point, 333);
      }
    }
    _onPswpTap(event) {
      if (event.detail.pointerType === "mouse") {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    }
    _onPswpBeforeChange() {
      if (this.photoSwipeInstance.items.length <= 1) {
        return;
      }
      const activeDot = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`);
      activeDot.setAttribute("aria-current", "true");
      getSiblings(activeDot).forEach((item) => item.removeAttribute("aria-current"));
    }
    _onPswpInitialZoomInEnd() {
      var _a;
      (_a = this.pswpUi) == null ? void 0 : _a.classList.remove("pswp__ui--hidden");
    }
    _onPswpInitialZoomOut() {
      var _a;
      (_a = this.pswpUi) == null ? void 0 : _a.classList.add("pswp__ui--hidden");
    }
    _onPswpParseVerticalMargin(item) {
      item.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60;
    }
  };
  
  var BuilderGallery = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
      LibraryLoader.load("photoswipe");
    }
    disconnectedCallback() {
      var _a;
      super.disconnectedCallback();
      (_a = this.photoSwipeInstance) == null ? void 0 : _a.destroy();
    }
    async attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      switch (name) {
        case "open":
          if (this.open) {
            await LibraryLoader.load("photoswipe");
            this._openPhotoSwipe();
          }
      }
    }
    async _openPhotoSwipe() {
      const items = await this._buildItems();
      this.photoSwipeInstance = new window.ThemePhotoSwipe(this, PhotoSwipeUi, items, {
        index: items.findIndex((item) => item.selected),
        maxSpreadZoom: this.maxSpreadZoom,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        closeOnVerticalDrag: MediaFeatures.supportsHover(),
        showHideOpacity: true,
        arrowKeys: true,
        history: false,
        getThumbBoundsFn: () => {
          
          const 
            thumbnail = this.card.querySelector(".builder-card__images"), 
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop, 
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
        getDoubleTapZoom: (isMouseClick, item) => {
          if (isMouseClick) {
            return item.w > item.h ? 1.6 : 1;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        }
      });
      let lastWidth = null;
      this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize, {
        apply: (target, thisArg, argArray) => {
          if (lastWidth !== window.innerWidth) {
            target(arguments);
            lastWidth = window.innerWidth;
          }
        }
      });
      this.photoSwipeInstance.listen("close", () => {
        this.open = false;
      });
      this.photoSwipeInstance.init();
    }
    async _buildItems() {

      const
      // activeImages = Array.from(this.mediaList.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')),
      // product = await ProductLoader.load(this.getAttribute("product-handle"));
      activeImages = this.activeImages;

      let data = await this.getData();

      return Promise.resolve(activeImages.map((item) => {

        if (data == "option") {

          // For metaobjects, we need to extract media info from the DOM element
          const imageElement = item.firstElementChild?.querySelector('img');
          if (!imageElement) {
            return null;
          }

          // Get the aspect ratio from the wrapper's CSS custom property
          const imageWrapper = item.firstElementChild;
          const aspectRatio = parseFloat(getComputedStyle(imageWrapper).getPropertyValue('--aspect-ratio')) || 1;

          // Get the current image source
          let imageSrc = imageElement.currentSrc || imageElement.src;

          // Extract the base URL without size parameters for Shopify CDN images
          // Shopify CDN URLs have size parameters like _1200x or _1200x1200 before the extension
          let baseImageSrc = imageSrc;
          const sizeParamMatch = imageSrc.match(/^(.+)_\d+x\d*(\.[^.?]+)(\?.*)?$/);
          if (sizeParamMatch) {
            baseImageSrc = sizeParamMatch[1] + sizeParamMatch[2] + (sizeParamMatch[3] || '');
          }

          // Get the maximum width from the srcset attribute
          // The srcset contains entries like "url 1200w, url 1800w"
          let maxWidth = 3000; // Default fallback
          if (imageElement.srcset) {
            const srcsetEntries = imageElement.srcset.split(',');
            const widths = srcsetEntries.map(entry => {
              const match = entry.trim().match(/(\d+)w$/);
              return match ? parseInt(match[1]) : 0;
            });
            maxWidth = Math.max(...widths, imageElement.naturalWidth || 0);
          } else {
            maxWidth = imageElement.naturalWidth || 3000;
          }

          // Build a media object structure similar to Shopify's product media
          const matchedMedia = {
            id: parseInt(item.getAttribute("data-media-id")),
            preview_image: {
              src: baseImageSrc,
              width: maxWidth,
              aspect_ratio: aspectRatio
            },
            aspect_ratio: aspectRatio
          };

          const supportedSizes = getSupportedSizes(matchedMedia, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]);
          const desiredWidth = Math.min(supportedSizes[supportedSizes.length - 1], window.innerWidth);

          // Generate the sized URL
          const sizedUrl = getSizedMediaUrl(matchedMedia, `${Math.ceil(Math.min(desiredWidth * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`);

          return {
            selected: item.classList.contains("is-selected"),
            src: sizedUrl || imageSrc, // Fallback to original src if getSizedMediaUrl fails
            msrc: imageElement.currentSrc || imageElement.src,
            originalMedia: matchedMedia,
            w: desiredWidth,
            h: parseInt(desiredWidth / aspectRatio)
          };

        }
        else {
          const
            matchedMedia = data["media"].find((media) => media.id === parseInt(item.getAttribute("data-media-id"))),
            supportedSizes = getSupportedSizes(matchedMedia, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]),
            desiredWidth = Math.min(supportedSizes[supportedSizes.length - 1], window.innerWidth);

          return {
            selected: item.classList.contains("is-selected"),
            src: getSizedMediaUrl(matchedMedia, `${Math.ceil(Math.min(desiredWidth * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`),
            msrc: item.firstElementChild.currentSrc,
            originalMedia: matchedMedia,
            w: desiredWidth,
            h: parseInt(desiredWidth / matchedMedia["aspect_ratio"])
          };
        }


      }));

    }
    get activeImages() {
      return Array.from(this.mediaList.querySelectorAll('.builder__media-item[data-media-type="image"]:not(.is-filtered)'));
    }
    get mediaList() {
      return this.querySelector(`.builder-gallery__media-list`) || document.getElementById(this.mediaListId);
    }
    get mediaListId() {
      return this.dataset.mediaList;
    }
    get dataType() {
      let data;
      
      return data;
    }
    get card() {
      return document.getElementById(this.cardId);
    }
    get cardId() {
      return this.dataset.cardId;
    }
    async getData() {
      let data;
      switch (this.dataset.stepType) {
        case 'product':
          data = await ProductLoader.load(this.dataset.handle);
          break;
        case 'option':
          data = 'option';
          break;
      };
      return data;
    }

  };
  
  
  window.customElements.define("builder-main", Builder);
  window.customElements.define("builder-controls", BuilderControls);
  window.customElements.define("builder-navigation", BuilderNavigation);
  window.customElements.define("builder-navigation-item", BuilderNavigationItem);
  window.customElements.define("builder-steps", BuilderSteps);
  window.customElements.define("builder-step", BuilderStep);
  window.customElements.define("builder-substep", BuilderSubstep);
  window.customElements.define("builder-substeps", BuilderSubsteps);
  window.customElements.define("builder-cards", BuilderCards);
  window.customElements.define("builder-card", BuilderCard);
  window.customElements.define("builder-scroll-indicator", BuilderScrollIndicator);
  window.customElements.define("builder-tooltip", BuilderTooltip);
  window.customElements.define("builder-gallery", BuilderGallery);
  window.customElements.define("builder-order-summary", BuilderOrderSummary);
  window.customElements.define("builder-viewer-overlay", BuilderViewerOverlay);
  window.customElements.define("builder-viewer-controls", BuilderViewerControls);
  window.customElements.define("builder-viewer-caption", BuilderViewerCaption);
  window.customElements.define("builder-viewer", BuilderViewer);
  window.customElements.define("builder-cart-group", BuilderCartGroup);
  window.customElements.define("builder-cart-group-remove", BuilderCartGroupRemove);
  window.customElements.define("builder-cart-group-quantity", BuilderCartGroupQuantity);
  window.customElements.define('builder-product-step', BuilderProductStep);

  document.querySelectorAll("builder-main").forEach((el) => {
    el._init();
  });

  function tradeDiscountMultiplier() {
    return (1 - (window.themeVariables.settings.trade_discount / 100));
  }

  function applyTradeDiscount(price) {
    const priceDiscounted = price * tradeDiscountMultiplier();
    return Number(priceDiscounted);
  }

  function bSelectorToClass (selector) {
    return selector.replace('.', '');
  }

  function bIsDomElement(obj) {
    return obj instanceof Element; // or HTMLElement
  }

  function trimBuilderPrefix(text) {
    let trimmed = text;
    trimmed = trimmed.replaceAll(window.lightbuilder.builder.settings.prefix, "");
    return trimmed;
  }

  function findVariantByOptions(variants, selectedOptions) {
    /*
    variants - Array of variants on product data json.
    selectionOptions - Array of selected option names.
    */
    return variants.find(variant =>
      selectedOptions.every(option =>
        variant.options.includes(option)
      )
    );
  }

  function getSelectionTitlesFromSteps(steps) {
    return steps.map(step => 
      step.querySelector(builderSelectors.selected)?.getAttribute('data-title')
    );
  }

  function mapTitlesFromSteps(steps) {
    return steps.reduce((acc, step, index) => {
      const title = step.querySelector(builderSelectors.selected)?.getAttribute('data-title');
      if (title) acc[index] = title;
      return acc;
    }, {});
  }

  function getVariantFromOptions(variantsData, options) {

    const variants = variantsData;

    if (!variants || variants.length === 0) {
      return null;
    }

    // Normalise input to an ordered array of option values.
    let optionValues;

    if (Array.isArray(options)) {
      optionValues = options;
    } else if (options && typeof options === 'object') {
      // Object keyed by position (e.g. { "1": "Brass", "2": "Large" }).
      // Sort by position key to produce an ordered array.
      optionValues = Object.keys(options)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((key) => options[key]);
    } else {
      return null;
    }

    if (optionValues.length === 0) {
      return null;
    }

    return variants.find((variant) => {
      return optionValues.every((value, index) => variant.options[index] === value);
    }) || null;

  }

  function bAnimate(target, transitionType, delay = 0, duration = 350) {

    // If no target is provided, use the element that called this function
    if (!target) {
      if (bIsDomElement(this)) {
        target = this;
      }
      else {
        return;
      }
    }

    let = delay ? delay : 0;
    let = duration ? duration : 350;

    let animation = null; // Custom Animation keyframe effect applied to the DOM element. Returned by this function.

    switch (transitionType) {
      case 'enter':
        duration = 800;
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(target, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(100px)", "translateY(0)"] }, { duration: duration, delay: delay, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" })
        ]));
        break;
      case 'leave':
        duration = 350;
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(target, { opacity: [1, 0], visibility: ["visible", "hidden"], transform: ["translateY(0)", "translateY(-100px)"] }, { duration: duration, delay: delay, easing: "cubic-bezier(0.600, -0.280, 0.735, 0.045)" })
        ]));
        break;
      case 'blinkOut':
        duration = 150;
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(target, { opacity: [1, 0], visibility: ["visible", "hidden"]}, { duration: duration, delay: delay, easing: "cubic-bezier(0.600, -0.280, 0.735, 0.045)" })
        ]));
        break;
      case 'blinkIn':
        duration = 150;
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(target, { opacity: [0, 1], visibility: ["hidden", "visible"]}, { duration: duration, delay: delay, easing: "cubic-bezier(0.600, -0.280, 0.735, 0.045)" })
        ]));
        break;
    }

    return animation;

  }

  const bUtil = {

    
  }

})();
/*!
* focus-trap 6.7.1
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
